(function () {
  var FORM_SELECTOR = '#la-prescription-form';
  var ENHANCED_MARKER = '.ciw-la-manual-rx-card';
  var MQ_MOBILE_RX = window.matchMedia('(max-width: 749px)');

  function isMobileRx() {
    return MQ_MOBILE_RX.matches;
  }

  function isContactLensHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function getManualRxContentBody(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return document.querySelector(
        '#lensadvizor-prescription-modal .la-prescription-modal-content-body'
      );
    }
    return form.closest('.la-prescription-modal-content-body');
  }

  function hideManualRxContentBodyForEnhance() {
    if (!isMobileRx()) return;
    var contentBody = getManualRxContentBody();
    if (!contentBody) return;
    contentBody.style.setProperty('visibility', 'hidden', 'important');
    contentBody.setAttribute('data-ciw-la-manual-rx-pending', '1');
  }

  function revealManualRxContentBodyAfterEnhance(form) {
    if (!isMobileRx()) return;
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || !form.classList.contains('ciw-la-manual-rx--ready')) return;
    var contentBody = getManualRxContentBody(form);
    if (!contentBody || contentBody.getAttribute('data-ciw-la-manual-rx-pending') !== '1') return;
    contentBody.style.removeProperty('visibility');
    contentBody.removeAttribute('data-ciw-la-manual-rx-pending');
  }

  function clearManualRxContentBodyPendingHide() {
    var contentBody = document.querySelector(
      '#lensadvizor-prescription-modal .la-prescription-modal-content-body[data-ciw-la-manual-rx-pending]'
    );
    if (!contentBody) return;
    contentBody.style.removeProperty('visibility');
    contentBody.removeAttribute('data-ciw-la-manual-rx-pending');
  }

  function isContactLensFormStep() {
    return isContactLensHost() && !!document.querySelector('.la-quantity-selector-wrapper');
  }

  function getContactLensEyeQuantities() {
    var la = window.LensAdvizor;
    if (!la || !la.response || !la.response.manually) {
      return { odRight: null, osLeft: null };
    }

    return {
      odRight: la.response.manually.od_right ? la.response.manually.od_right.quantity : null,
      osLeft: la.response.manually.os_left ? la.response.manually.os_left.quantity : null
    };
  }

  function syncContactLensEyeBlocks(form) {
    if (!isContactLensHost() || !form) {
      return;
    }

    var qty = getContactLensEyeQuantities();
    var odActive = qty.odRight === null || qty.odRight > 0;
    var osActive = qty.osLeft === null || qty.osLeft > 0;

    form.querySelectorAll('.ciw-la-rx-eye-block--od').forEach(function (block) {
      block.classList.toggle('ciw-la-rx-eye-block--inactive', !odActive);
    });
    form.querySelectorAll('.ciw-la-rx-eye-block--os').forEach(function (block) {
      block.classList.toggle('ciw-la-rx-eye-block--inactive', !osActive);
    });
  }

  function cardHasAddGrid(card) {
    if (!card) {
      return false;
    }

    if (card.querySelector('.ciw-la-rx-grid--add')) {
      return true;
    }

    var grid = card.querySelector('.ciw-la-rx-grid--eye-with-add');
    if (!grid) {
      return false;
    }

    return grid.querySelectorAll('.ciw-la-rx-grid__col').length >= 4;
  }

  function cardShouldHaveAddGrid(form) {
    var rightRx = form && form.querySelector('.la-right-rx-container');
    return !!(rightRx && shouldShowAddPower(getFormItems(rightRx)));
  }

  function isConfirmInCard(form, card) {
    if (!form || !card) {
      return false;
    }

    var checkbox = findPrescriptionConfirmCheckbox(form);
    return !!(checkbox && card.contains(checkbox));
  }

  function isConfirmMissingFromCard(form, card) {
    if (!form || isContactLensHost()) {
      return false;
    }

    card = card || form.querySelector('.ciw-la-manual-rx-card--mobile');
    if (!card) {
      return false;
    }

    var checkbox = findPrescriptionConfirmCheckbox(form);
    return !!(checkbox && !card.contains(checkbox));
  }

  function isManualRxEnhancementStale(form) {
    if (!form) {
      return false;
    }

    var card = form.querySelector(ENHANCED_MARKER);
    if (!card) {
      return false;
    }

    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    if (!fieldsWrapper || !fieldsWrapper.contains(card) || !form.querySelector('.ciw-la-manual-rx-card--mobile')) {
      return true;
    }

    if (cardShouldHaveAddGrid(form) !== cardHasAddGrid(card)) {
      return true;
    }

    if (!cardRxGridHasSelects(card)) {
      return true;
    }

    if (isConfirmMissingFromCard(form, card)) {
      return true;
    }

    return false;
  }

  function normalizeRxFieldName(name) {
    name = String(name || '')
      .toLowerCase()
      .replace(/[\s_\[\].]+/g, '');

    if (name === 'sphere' || name === 'sph' || name.indexOf('sphere') >= 0) {
      return 'sph';
    }
    if (name === 'cylinder' || name === 'cyl' || name.indexOf('cylinder') >= 0) {
      return 'cyl';
    }
    if (name === 'axis' || name.indexOf('axis') >= 0) {
      return 'axis';
    }
    if (name === 'add' || name.indexOf('add') >= 0) {
      return 'add';
    }

    return name;
  }

  function getItemFieldName(item) {
    if (!item) {
      return '';
    }

    var field = item.querySelector('[data-field-name]');
    if (field) {
      return normalizeRxFieldName(field.getAttribute('data-field-name'));
    }

    var select = item.querySelector('select');
    if (select) {
      return normalizeRxFieldName(getSelectFieldName(select));
    }

    var label = item.querySelector('label');
    return normalizeRxFieldName(label ? label.textContent : '');
  }

  function getCoreFieldOrderIndex(item) {
    var name = getItemFieldName(item);
    if (name === 'sph') {
      return 0;
    }
    if (name === 'cyl') {
      return 1;
    }
    if (name === 'axis') {
      return 2;
    }
    return 99;
  }

  function itemHasRxSelect(item) {
    return !!(item && item.querySelector('select'));
  }

  function countContainerCoreSelects(container) {
    if (!container) {
      return 0;
    }

    return getCoreItems(getFormItems(container)).filter(itemHasRxSelect).length;
  }

  function areRxContainersReady(rightRx, leftRx) {
    return countContainerCoreSelects(rightRx) >= 3 && countContainerCoreSelects(leftRx) >= 3;
  }

  function cardRxGridHasSelects(card) {
    if (!card) {
      return false;
    }

    var odGrid = card.querySelector('.ciw-la-rx-eye-block--od .ciw-la-rx-grid--eye');
    var osGrid = card.querySelector('.ciw-la-rx-eye-block--os .ciw-la-rx-grid--eye');
    return !!(
      odGrid &&
      osGrid &&
      odGrid.querySelector('select') &&
      osGrid.querySelector('select')
    );
  }

  function canRefreshRxInPlace(form, card, rightRx, leftRx) {
    if (!form || !card || !rightRx || !leftRx) {
      return false;
    }

    if (cardRxGridHasSelects(card)) {
      return true;
    }

    return areRxContainersReady(rightRx, leftRx);
  }

  function refreshRxSectionInCard(form, card, rightRx, leftRx) {
    if (!form || !card || !rightRx || !leftRx) {
      return false;
    }

    var section = card.querySelector('.ciw-la-manual-rx-section--rx');
    if (!section) {
      return false;
    }

    restoreNativeRxFields(form, card);
    section.textContent = '';
    section.appendChild(buildRxTable(rightRx, leftRx));
    hideElement(rightRx);
    hideElement(leftRx);
    syncContactLensEyeBlocks(form);
    sanitizeManualRxValidation(form);
    if (!isContactLensHost()) {
      ensureManualRxCardTail(form, card);
    }
    document.dispatchEvent(new CustomEvent('ciw-la-manual-rx:enhanced'));
    return true;
  }

  function salvageGridSelectsToContainers(form, card) {
    if (!form || !card) {
      return;
    }

    var rightRx = form.querySelector('.la-right-rx-container');
    var leftRx = form.querySelector('.la-left-rx-container');

    function salvageSelects(selects, container) {
      if (!container) {
        return;
      }

      var orphanSelects = Array.from(selects).filter(function (select) {
        return !container.contains(select);
      });

      if (!orphanSelects.length) {
        return;
      }

      var emptyItems = getFormItems(container).filter(function (item) {
        return !item.querySelector('select');
      });

      orphanSelects.forEach(function (select, index) {
        var fieldName = getSelectFieldName(select);
        var formItem = fieldName ? findFormItemForField(container, fieldName) : null;

        if (formItem && !formItem.querySelector('select')) {
          restoreSelectToFormItem(select, formItem);
          return;
        }

        if (emptyItems[index] && !emptyItems[index].querySelector('select')) {
          restoreSelectToFormItem(select, emptyItems[index]);
          return;
        }

        container.appendChild(select);
      });
    }

    function salvageEye(eyeClass, container) {
      var eyeBlock = card.querySelector(eyeClass);
      if (!eyeBlock) {
        return;
      }

      salvageSelects(eyeBlock.querySelectorAll('.ciw-la-rx-grid__col-field select'), container);
    }

    salvageEye('.ciw-la-rx-eye-block--od', rightRx);
    salvageEye('.ciw-la-rx-eye-block--os', leftRx);
  }

  function getSelectFieldName(select) {
    if (!select) {
      return null;
    }

    if (select.getAttribute('data-field-name')) {
      return select.getAttribute('data-field-name');
    }

    var marked = select.closest('[data-field-name]');
    if (marked) {
      return marked.getAttribute('data-field-name');
    }

    return null;
  }

  function findFormItemForField(container, fieldName) {
    if (!container || !fieldName) {
      return null;
    }

    var items = container.querySelectorAll('.la-form-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].querySelector('[data-field-name="' + fieldName + '"]')) {
        return items[i];
      }
    }

    return null;
  }

  function restoreSelectToFormItem(select, formItem) {
    if (!select || !formItem) {
      return;
    }

    var wrap = select.closest('.ciw-la-rx-select');
    var node = wrap || select;
    if (formItem.contains(node)) {
      return;
    }

    formItem.appendChild(node);

    var label = formItem.querySelector('label.ciw-la-manual-rx-hidden');
    if (label) {
      label.classList.remove('ciw-la-manual-rx-hidden');
    }
  }

  function restoreContainerFromGridSelects(container, gridSelects) {
    if (!container) {
      return;
    }

    gridSelects = Array.from(gridSelects || []);
    var claimed = new Set();

    getFormItems(container).forEach(function (item) {
      if (item.querySelector('select')) {
        return;
      }

      var field = item.querySelector('[data-field-name]');
      var fieldName = field ? field.getAttribute('data-field-name') : getItemFieldName(item);
      if (!fieldName) {
        return;
      }

      var match = gridSelects.find(function (select) {
        return !claimed.has(select) && normalizeRxFieldName(getSelectFieldName(select)) === normalizeRxFieldName(fieldName);
      });

      if (!match && normalizeRxFieldName(fieldName) === 'add') {
        match = gridSelects.find(function (select, index) {
          return !claimed.has(select) && index === gridSelects.length - 1;
        });
      }

      if (match) {
        claimed.add(match);
        restoreSelectToFormItem(match, item);
      }
    });

    var emptyItems = getFormItems(container).filter(function (item) {
      return !item.querySelector('select');
    });

    gridSelects.forEach(function (select) {
      if (claimed.has(select) || container.contains(select)) {
        return;
      }

      var fieldName = getSelectFieldName(select);
      var formItem = fieldName ? findFormItemForField(container, fieldName) : null;
      if (formItem && !formItem.querySelector('select')) {
        restoreSelectToFormItem(select, formItem);
        claimed.add(select);
        return;
      }

      if (emptyItems.length) {
        restoreSelectToFormItem(select, emptyItems.shift());
        claimed.add(select);
      }
    });
  }

  function restoreNativeRxFields(form, card) {
    card = card || (form && form.querySelector(ENHANCED_MARKER));
    if (!form || !card) {
      return;
    }

    var rightRx = form.querySelector('.la-right-rx-container');
    var leftRx = form.querySelector('.la-left-rx-container');
    function restoreEye(eyeClass, container) {
      var eyeBlock = card.querySelector(eyeClass);
      if (!eyeBlock || !container) {
        return;
      }

      restoreContainerFromGridSelects(
        container,
        eyeBlock.querySelectorAll('.ciw-la-rx-grid__col-field select')
      );
    }

    restoreEye('.ciw-la-rx-eye-block--od', rightRx);
    restoreEye('.ciw-la-rx-eye-block--os', leftRx);

    if (rightRx) {
      rightRx.classList.remove('ciw-la-manual-rx-hidden');
    }
    if (leftRx) {
      leftRx.classList.remove('ciw-la-manual-rx-hidden');
    }
  }

  function restoreManualRxDom(form) {
    if (!form) {
      return;
    }

    var card = form.querySelector(ENHANCED_MARKER);
    if (!card) {
      return;
    }

    var fieldsWrapper = form.querySelector('.la-fields-wrapper');

    restoreNativeRxFields(form, card);

    var pdContainer = card.querySelector('.la-pd-container');
    if (pdContainer) {
      stopPdPresetWatch(pdContainer);
      if (fieldsWrapper) {
        fieldsWrapper.appendChild(pdContainer);
      } else {
        form.appendChild(pdContainer);
      }
    }

    var prismSection = card.querySelector('.ciw-la-manual-rx-section--prism');
    if (prismSection) {
      if (fieldsWrapper) {
        fieldsWrapper.appendChild(prismSection);
      } else {
        form.appendChild(prismSection);
      }
    }

    var confirmRow = card.querySelector('.ciw-la-manual-rx-confirm-row');
    if (!confirmRow) {
      confirmRow = findPrescriptionConfirmRow(form);
    }
    if (confirmRow && card.contains(confirmRow)) {
      if (confirmRow.dataset.ciwLaFallbackConfirm === '1') {
        confirmRow.remove();
      } else if (fieldsWrapper) {
        fieldsWrapper.appendChild(confirmRow);
      } else {
        form.appendChild(confirmRow);
      }
    }
  }

  function resetManualRxEnhancement(form) {
    if (!form) {
      return;
    }

    stopConfirmWatch(form);
    delete form.dataset.ciwLaConfirmWatch;

    restoreManualRxDom(form);

    form.querySelectorAll(ENHANCED_MARKER).forEach(function (node) {
      salvageGridSelectsToContainers(form, node);
      node.remove();
    });
    form.classList.remove('ciw-la-manual-rx-form', 'ciw-la-manual-rx-form--mobile', 'ciw-la-manual-rx--ready');

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.remove('ciw-la-manual-rx-step', 'ciw-la-manual-rx-step--mobile');
    }
  }

  function createCheckboxRow(labelText, checked, onChange) {
    var row = document.createElement('label');
    row.className = 'ciw-la-manual-rx-checkbox';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'ciw-la-manual-rx-checkbox__input';
    input.checked = !!checked;

    var text = document.createElement('span');
    text.className = 'ciw-la-manual-rx-checkbox__label';
    text.textContent = labelText;

    input.addEventListener('change', function () {
      onChange(input.checked);
    });

    row.appendChild(input);
    row.appendChild(text);
    return row;
  }

  function hideElement(el) {
    if (!el) return;
    el.classList.add('ciw-la-manual-rx-hidden');
  }

  function stripRequiredFromFields(root) {
    if (!root) {
      return;
    }

    root.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.removeAttribute('required');
      field.required = false;
    });
  }

  function sanitizeManualRxValidation(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || !form.querySelector('.ciw-la-manual-rx-card--mobile')) {
      return;
    }

    form.querySelectorAll('.ciw-la-manual-rx-hidden').forEach(stripRequiredFromFields);

    var pdFields = form.querySelector('#la-pd-fields-container');
    if (pdFields) {
      pdFields.querySelectorAll(':scope > :not(.ciw-la-pd-split)').forEach(stripRequiredFromFields);
    }

    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    if (uploadWrapper && uploadWrapper.classList.contains('ciw-la-manual-rx-hidden') && !isPrismEnabled(form)) {
      stripRequiredFromFields(uploadWrapper);
    }

    var prismSection = form.querySelector('.ciw-la-manual-rx-section--prism');
    if (prismSection) {
      prismSection.querySelectorAll('.la-prism-select, [data-field-name="horizontal"], .la-prescription-fields-wrapper select').forEach(function (field) {
        field.removeAttribute('required');
        field.required = false;
      });
    }

    if (!isPrismEnabled(form)) {
      setPrismUploadRequired(false);
    }
  }

  function showPrismUploadValidationError(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || !isPrismEnabled(form)) {
      return false;
    }

    var fileInput = getPrescriptionFileInput(form);
    var panel = form.querySelector('.ciw-la-prism-upload');
    if (!fileInput || !fileInput.hasAttribute('required')) {
      if (panel) {
        panel.classList.remove('ciw-la-prism-upload--error');
      }
      return false;
    }

    if (fileInput.files && fileInput.files[0]) {
      if (panel) {
        panel.classList.remove('ciw-la-prism-upload--error');
      }
      return false;
    }

    if (panel) {
      panel.classList.add('ciw-la-prism-upload--error');
      panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    return true;
  }

  function bindManualRxSubmitGuard() {
    if (document.documentElement.dataset.ciwLaManualRxSubmitGuard === '1') {
      return;
    }

    document.documentElement.dataset.ciwLaManualRxSubmitGuard = '1';

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.id !== 'la-prescription-form' || !form.querySelector('.ciw-la-manual-rx-card--mobile')) {
          return;
        }

        sanitizeManualRxValidation(form);
      },
      true
    );

    document.addEventListener(
      'invalid',
      function (event) {
        var field = event.target;
        if (!field || !field.form || field.form.id !== 'la-prescription-form') {
          return;
        }

        sanitizeManualRxValidation(field.form);
        showPrismUploadValidationError(field.form);
      },
      true
    );
  }

  function getFormItems(container) {
    return Array.from(container.querySelectorAll('.la-form-item'));
  }

  function itemHasAddField(item) {
    if (!item) {
      return false;
    }

    var field = item.querySelector('[data-field-name="add"]');
    if (field && field.closest('.la-form-item') === item) {
      return true;
    }

    return getItemFieldName(item) === 'add';
  }

  function getRowItems(items, hasAdd) {
    return items.filter(function (item) {
      var field = item.querySelector('[data-field-name]');
      if (!field) return false;
      var name = field.getAttribute('data-field-name');
      if (name === 'add') {
        return hasAdd;
      }
      return true;
    });
  }

  function getCoreItems(items) {
    return items
      .filter(function (item) {
        if (itemHasAddField(item)) {
          return false;
        }

        if (item.querySelector('select')) {
          return true;
        }

      var field = item.querySelector('[data-field-name]');
        return field && normalizeRxFieldName(field.getAttribute('data-field-name')) !== 'add';
      })
      .sort(function (a, b) {
        var orderDiff = getCoreFieldOrderIndex(a) - getCoreFieldOrderIndex(b);
        if (orderDiff !== 0) {
          return orderDiff;
        }

        return items.indexOf(a) - items.indexOf(b);
    });
  }

  function getAddItem(items) {
    return items.find(itemHasAddField) || null;
  }

  function hasVisibleAdd(rightItems) {
    return rightItems.some(function (item) {
      return itemHasAddField(item) && item.offsetParent !== null;
    });
  }

  var CORE_COLUMNS = [
    { name: 'Sphere', acronym: '(SPH)' },
    { name: 'Cylinder', acronym: '(CYL)' },
    { name: 'Axis', acronym: '(AXIS)' }
  ];

  var ADD_COLUMN = { name: 'Add', acronym: '(ADD)' };

  function getSelectedUsageLabel() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      if (selected.title) {
        if (la.Translation && typeof la.Translation.getTranslatedText === 'function') {
          try {
            return la.Translation.getTranslatedText(selected.title) || '';
          } catch (err) {
            /* fall through */
          }
        }
        if (typeof selected.title === 'string') {
          return selected.title;
        }
      }
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) {
      return '';
    }

    var usageWrapper = modal.querySelector(
      '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review):not(.la-render-addons)'
    );
    if (!usageWrapper) {
      return '';
    }

    var checked = usageWrapper.querySelector('input[type="radio"]:checked');
    if (!checked) {
      return '';
    }

    var btn = checked.closest('.la-label-btn, label.la-label-btn, label');
    if (!btn) {
      return '';
    }

    var titleEl = btn.querySelector('.la-label-title');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function shouldShowAddPower(rightItems) {
    if (isContactLensHost()) {
      return rightItems.some(itemHasAddField);
    }

    if (!rightItems.some(itemHasAddField)) {
      return false;
    }

    var la = window.LensAdvizor;
    var type = la && la.response ? String(la.response.prescriptionType || '').toLowerCase() : '';
    var label = getSelectedUsageLabel().toLowerCase();

    if (type === 'progressive' || type === 'bifocal') {
      return true;
    }

    if (label.indexOf('progressive') >= 0) {
      return true;
    }

    if (label.indexOf('bifocal') >= 0) {
      return true;
    }

    return false;
  }

  function hideAddFields(items) {
    items.forEach(function (item) {
      if (itemHasAddField(item)) {
        hideElement(item);
      }
    });
  }

  function buildColumnHead(column) {
    var head = document.createElement('div');
    head.className = 'ciw-la-rx-grid__col-head';

    var name = document.createElement('span');
    name.className = 'ciw-la-rx-grid__col-name';
    name.textContent = column.name;

    var acronym = document.createElement('span');
    acronym.className = 'ciw-la-rx-grid__col-acronym';
    acronym.textContent = column.acronym;

    head.appendChild(name);
    head.appendChild(acronym);
    return head;
  }

  function appendItemToCell(cell, item) {
    hideElement(item.querySelector('label'));

    var wrap = item.querySelector('.ciw-la-rx-select');
    if (wrap) {
      cell.appendChild(wrap);
      return;
    }

    var select = item.querySelector('select');
    if (select) {
      cell.appendChild(select);
    }
  }

  function syncColumnDisabledState(col, select) {
    if (!col || !select) {
      return;
    }

    col.classList.toggle('ciw-la-rx-grid__col--disabled', select.disabled);
  }

  function observeSelectDisabled(select, col) {
    if (!select || !col || select.dataset.ciwLaDisabledObserved === '1') {
      return;
    }

    select.dataset.ciwLaDisabledObserved = '1';
    syncColumnDisabledState(col, select);

    new MutationObserver(function () {
      syncColumnDisabledState(col, select);
    }).observe(select, { attributes: true, attributeFilter: ['disabled'] });
  }

  function bindEyeGridState(grid) {
    grid.querySelectorAll('.ciw-la-rx-grid__col').forEach(function (col) {
      observeSelectDisabled(col.querySelector('select'), col);
    });
  }

  function buildEyeColumnGrid(items, hasAdd) {
    var grid = document.createElement('div');
    grid.className = 'ciw-la-rx-grid ciw-la-rx-grid--eye';
    grid.setAttribute('role', 'group');

    var rowItems = getCoreItems(items);
    var addItem = hasAdd ? getAddItem(items) : null;
    if (addItem) {
      rowItems.push(addItem);
      grid.classList.add('ciw-la-rx-grid--eye-with-add');
    }

    var columns = addItem ? CORE_COLUMNS.concat([ADD_COLUMN]) : CORE_COLUMNS;

    rowItems.forEach(function (item, index) {
      var col = document.createElement('div');
      col.className = 'ciw-la-rx-grid__col';
        if (index > 0) {
        col.classList.add('ciw-la-rx-grid__col--split');
        }

      var field = document.createElement('div');
      field.className = 'ciw-la-rx-grid__col-field';
        appendItemToCell(field, item);

      col.appendChild(buildColumnHead(columns[index] || { name: '', acronym: '' }));
      col.appendChild(field);
      grid.appendChild(col);
      });

    bindEyeGridState(grid);
    return grid;
  }

  function buildEyeBlock(title, items, rowClass, hasAdd) {
    var block = document.createElement('div');
    block.className = 'ciw-la-rx-eye-block ' + rowClass;

    var titleEl = document.createElement('div');
    titleEl.className = 'ciw-la-rx-eye-block__title';
    titleEl.textContent = title;
    block.appendChild(titleEl);
    block.appendChild(buildEyeColumnGrid(items, hasAdd));

    return block;
  }

  function buildRxTable(rightRx, leftRx) {
    var rightItems = getFormItems(rightRx);
    var leftItems = getFormItems(leftRx);
    var hasAdd = shouldShowAddPower(rightItems);

    if (!hasAdd) {
      hideAddFields(rightItems);
      hideAddFields(leftItems);
    }

    return buildMobileRxStack(rightItems, leftItems, hasAdd);
  }

  function buildMobileRxStack(rightItems, leftItems, hasAdd) {
    var stack = document.createElement('div');
    stack.className = 'ciw-la-rx-stack--mobile';

    stack.appendChild(buildEyeBlock('Right (OD)', rightItems, 'ciw-la-rx-eye-block--od', hasAdd));
    stack.appendChild(buildEyeBlock('Left (OS)', leftItems, 'ciw-la-rx-eye-block--os', hasAdd));

    return stack;
  }

  function buildManualRxHeading() {
    var heading = document.createElement('div');
    heading.className = 'ciw-la-manual-rx-heading';

    var title = document.createElement('h3');
    title.className = 'ciw-la-manual-rx-heading__title';
    title.textContent = isContactLensHost()
      ? 'Enter your contact lens prescription'
      : 'Enter your prescription';

    var trigger = document.createElement('div');
    trigger.className = 'ciw-la-rx-help-trigger ciw-la-rx-help-trigger--manual';
    trigger.innerHTML =
      '<button type="button" class="ciw-la-rx-help-trigger__link" data-ciw-la-rx-read-help-open>' +
      '<span class="ciw-la-rx-help-trigger__underline">How to read my prescription</span>' +
      '</button>' +
      '<button type="button" class="ciw-la-rx-help-trigger__icon" data-ciw-la-rx-read-help-open aria-label="How to read my prescription">' +
      '<span aria-hidden="true">?</span>' +
      '</button>';

    heading.appendChild(title);
    heading.appendChild(trigger);
    return heading;
  }

  function buildRxSection(rightRx, leftRx) {
    var section = document.createElement('div');
    section.className = 'ciw-la-manual-rx-section ciw-la-manual-rx-section--rx';
    section.appendChild(buildRxTable(rightRx, leftRx));

    hideElement(rightRx);
    hideElement(leftRx);

    return section;
  }

  function findNativeCommentField(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return null;
    }

    return (
      form.querySelector('#la-order-notes') ||
      form.querySelector('.la-order-notes-wrapper textarea[name="notes"]') ||
      form.querySelector('textarea[name="notes"]') ||
      null
    );
  }

  function getStoredCommentValue(form) {
    var la = window.LensAdvizor;
    if (la && la.response && typeof la.response.orderNote === 'string' && la.response.orderNote) {
      return la.response.orderNote;
    }

    var nativeField = findNativeCommentField(form);
    return nativeField ? String(nativeField.value || '') : '';
  }

  function syncCommentToLensAdvizor(value) {
    var la = window.LensAdvizor;
    if (la && la.response) {
      la.response.orderNote = value || '';
    }
  }

  function syncCommentToNativeField(nativeField, value) {
    if (!nativeField) {
      return;
    }

    nativeField.value = value || '';
    nativeField.dispatchEvent(new Event('input', { bubbles: true }));
    nativeField.dispatchEvent(new Event('change', { bubbles: true }));
    nativeField.dispatchEvent(new Event('keyup', { bubbles: true }));
  }

  function ensureHiddenNotesField(form) {
    if (!form) {
      return null;
    }

    var existing = form.querySelector('#ciw-la-manual-rx-notes-sync');
    if (existing) {
      return existing;
    }

    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'notes';
    hidden.id = 'ciw-la-manual-rx-notes-sync';
    form.appendChild(hidden);
    return hidden;
  }

  function hideNativeCommentWrappers(form) {
    if (!form) {
      return;
    }

    form.querySelectorAll('.la-order-notes-wrapper').forEach(function (wrapper) {
      if (!wrapper.closest('.ciw-la-manual-rx-section--comment')) {
        hideElement(wrapper);
      }
    });
  }

  function isCustomManualRxCheckbox(input) {
    if (!input) {
      return false;
    }

    return !!input.closest(
      '.ciw-la-manual-rx-dual-pd, .ciw-la-manual-rx-prism-toggle, .ciw-la-contact-quantity, .ciw-la-manual-rx-checkbox'
    );
  }

  function findPrescriptionConfirmCheckbox(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return null;
    }

    var checkbox = form.querySelector('#la-upload-confirmation');
    if (checkbox) {
      return checkbox;
    }

    var candidates = form.querySelectorAll(
      '.la-checkox-wrapper-label input[type="checkbox"], label.la-checkox-wrapper-label input[type="checkbox"]'
    );

    for (var i = candidates.length - 1; i >= 0; i--) {
      var input = candidates[i];
      if (isCustomManualRxCheckbox(input)) {
        continue;
      }

      var label = input.closest('.la-checkox-wrapper-label, label');
      var text = label ? String(label.textContent || '').toLowerCase() : '';
      if (
        text.indexOf('confirm') >= 0 ||
        (text.indexOf('prescription') >= 0 && text.indexOf('correct') >= 0)
      ) {
        return input;
      }
    }

    return null;
  }

  function isConfirmOnlyWrapper(wrapper) {
    if (!wrapper) {
      return false;
    }

    if (
      wrapper.querySelector(
        '.la-right-rx-container, .la-left-rx-container, .la-pd-container, #la-prescription-file, .la-form-item select, input[type="file"]'
      )
    ) {
      return false;
    }

    return wrapper.querySelectorAll('input[type="checkbox"]').length >= 1;
  }

  function findPrescriptionConfirmRowFromCheckbox(checkbox) {
    if (!checkbox) {
      return null;
    }

    var existing = checkbox.closest('.ciw-la-manual-rx-confirm-row');
    if (existing) {
      return existing;
    }

    var wrapper = checkbox.closest('.la-prescription-fields-wrapper');
    if (wrapper && isConfirmOnlyWrapper(wrapper)) {
      return wrapper;
    }

    var labelRow = checkbox.closest('.la-checkox-wrapper-label');
    if (labelRow) {
      return labelRow;
    }

    var label = checkbox.closest('label');
    if (label) {
      return label;
    }

    var parent = checkbox.parentElement;
    if (parent) {
      var checkboxes = parent.querySelectorAll('input[type="checkbox"]');
      if (
        checkboxes.length === 1 &&
        !parent.querySelector('select, input[type="file"], .la-form-item')
      ) {
        return parent;
      }
    }

    return labelRow || label || parent || null;
  }

  function findPrescriptionConfirmRow(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return null;
    }

    return findPrescriptionConfirmRowFromCheckbox(findPrescriptionConfirmCheckbox(form));
  }

  function isPrescriptionConfirmCheckbox(input) {
    if (!input || input.type !== 'checkbox' || isCustomManualRxCheckbox(input)) {
      return false;
    }

    if (input.id === 'la-upload-confirmation' || input.id === 'ciw-la-upload-confirmation-fallback') {
      return true;
    }

    if (input.name === 'la-upload-confirmation') {
      return true;
    }

    var label = input.closest('.la-checkox-wrapper-label, label');
    var text = label ? String(label.textContent || '').toLowerCase() : '';
    return text.indexOf('confirm') >= 0 || (text.indexOf('prescription') >= 0 && text.indexOf('correct') >= 0);
  }

  function findAllPrescriptionConfirmRows(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return [];
    }

    var rows = [];
    var seen = new Set();

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      if (!isPrescriptionConfirmCheckbox(input)) {
        return;
      }

      var row = findPrescriptionConfirmRowFromCheckbox(input);
      if (!row || seen.has(row)) {
        return;
      }

      seen.add(row);
      rows.push({ row: row, checkbox: input });
    });

    return rows;
  }

  function pickCanonicalPrescriptionConfirm(form, card) {
    var candidates = findAllPrescriptionConfirmRows(form);
    if (!candidates.length) {
      return { checkbox: null, row: null, candidates: candidates };
    }

    card = card || form.querySelector('.ciw-la-manual-rx-card--mobile');
    var uploadWrapper = form.querySelector('.la-upload-wrapper');

    function score(entry) {
      var points = 0;
      var row = entry.row;
      var checkbox = entry.checkbox;

      if (card && card.contains(row) && (!uploadWrapper || !uploadWrapper.contains(row))) {
        points += 100;
      }

      if (checkbox.id === 'la-upload-confirmation') {
        points += 50;
      }

      if (row.dataset.ciwLaFallbackConfirm !== '1') {
        points += 25;
      }

      if (uploadWrapper && uploadWrapper.contains(row)) {
        points -= 75;
      }

      return points;
    }

    candidates.sort(function (a, b) {
      return score(b) - score(a);
    });

    return {
      checkbox: candidates[0].checkbox,
      row: candidates[0].row,
      candidates: candidates
    };
  }

  var PRESCRIPTION_CONFIRM_LABEL_KEY = 'I confirm that my prescription is entered correctly';
  var PRESCRIPTION_CONFIRM_LABEL_FALLBACK =
    'By clicking this box, I confirm that the prescription values entered above are taken from a valid (not expired) prescription issued to me, signed by a licensed optometrist or ophthalmologist.';

  function readCustomPrescriptionConfirmLabel(la) {
    if (!la || !la.options) {
      return '';
    }

    var customJson = la.options.custom_translationJSON;
    if (!customJson || typeof customJson !== 'object') {
      return '';
    }

    var locales = ['EN', 'en', 'user'];
    var i;
    var locale;
    var bucket;
    var value;

    for (i = 0; i < locales.length; i++) {
      locale = customJson[locales[i]];
      if (!locale || typeof locale !== 'object') {
        continue;
      }

      bucket = locale.user || locale;
      if (!bucket || typeof bucket !== 'object') {
        continue;
      }

      value = bucket[PRESCRIPTION_CONFIRM_LABEL_KEY];
      if (typeof value === 'string' && value.trim()) {
        return value.trim();
      }
    }

    return '';
  }

  function getPrescriptionConfirmLabelText() {
    var la = window.LensAdvizor;

    if (la && la.Translation && typeof la.Translation.getTranslatedText === 'function') {
      try {
        var translated = la.Translation.getTranslatedText(PRESCRIPTION_CONFIRM_LABEL_KEY);
        if (typeof translated === 'string' && translated.trim()) {
          return translated.trim();
        }
      } catch (err) {
        /* fall through */
      }
    }

    var customLabel = readCustomPrescriptionConfirmLabel(la);
    if (customLabel) {
      return customLabel;
    }

    return PRESCRIPTION_CONFIRM_LABEL_FALLBACK;
  }

  function setPrescriptionConfirmLabelText(label, text) {
    if (!label) {
      return;
    }

    var textSpan = label.querySelector('.ciw-la-manual-rx-confirm-text');
    if (!textSpan) {
      textSpan = document.createElement('span');
      textSpan.className = 'ciw-la-manual-rx-confirm-text';
      label.appendChild(textSpan);
    }

    textSpan.textContent = text;
  }

  function syncPrescriptionConfirmLabel(confirmRow) {
    if (!confirmRow) {
      return;
    }

    if (confirmRow.dataset.ciwLaFallbackConfirm === '1') {
      syncFallbackPrescriptionConfirmLabel(confirmRow);
      return;
    }

    var label = confirmRow.matches('.la-checkox-wrapper-label, label')
      ? confirmRow
      : confirmRow.querySelector('.la-checkox-wrapper-label, label');

    if (label) {
      setPrescriptionConfirmLabelText(label, getPrescriptionConfirmLabelText());
    }
  }

  function syncFallbackPrescriptionConfirmLabel(confirmRow) {
    if (!confirmRow || confirmRow.dataset.ciwLaFallbackConfirm !== '1') {
      return;
    }

    var label = confirmRow.querySelector('.la-checkox-wrapper-label, label');
    if (!label) {
      return;
    }

    var text = getPrescriptionConfirmLabelText();
    var textSpan = label.querySelector('.ciw-la-manual-rx-confirm-text');

    if (!textSpan) {
      var child = label.lastChild;
      while (child && child.nodeType === Node.TEXT_NODE && !String(child.textContent || '').trim()) {
        var previous = child.previousSibling;
        label.removeChild(child);
        child = previous;
      }

      if (
        child &&
        child.nodeType === Node.TEXT_NODE &&
        String(child.textContent || '').trim() === PRESCRIPTION_CONFIRM_LABEL_KEY
      ) {
        label.removeChild(child);
      }
    }

    setPrescriptionConfirmLabelText(label, text);
  }

  function mergeDetachedConfirmControls(confirmRow) {
    if (!confirmRow) {
      return;
    }

    var checkbox =
      confirmRow.querySelector('#la-upload-confirmation') ||
      Array.from(confirmRow.querySelectorAll('input[type="checkbox"]')).find(isPrescriptionConfirmCheckbox);

    if (!checkbox) {
      return;
    }

    var label = confirmRow.querySelector('.la-checkox-wrapper-label, label');

    if (label && !label.contains(checkbox)) {
      label.insertBefore(checkbox, label.firstChild);
      if (checkbox.id) {
        label.setAttribute('for', checkbox.id);
      }
      return;
    }

    if (!label && checkbox.parentElement === confirmRow) {
      var textLabel = confirmRow.querySelector('label:not(:has(input[type="checkbox"]))');
      if (textLabel) {
        var merged = document.createElement('label');
        merged.className = 'la-form-field-label la-checkox-wrapper-label';
        merged.appendChild(checkbox);
        while (textLabel.firstChild) {
          merged.appendChild(textLabel.firstChild);
        }
        textLabel.remove();
        confirmRow.textContent = '';
        confirmRow.appendChild(merged);
      }
    }
  }

  function stripLensAdvizorConfirmInjection(label) {
    if (!label) {
      return;
    }

    var checkbox = label.querySelector('input[type="checkbox"]');
    var textSpan = label.querySelector('.ciw-la-manual-rx-confirm-text');

    Array.from(label.childNodes).forEach(function (node) {
      if (node === checkbox || node === textSpan) {
        return;
      }

      node.remove();
    });
  }

  function normalizePrescriptionConfirmRow(confirmRow) {
    if (!confirmRow) {
      return;
    }

    mergeDetachedConfirmControls(confirmRow);

    var checkboxes = Array.from(confirmRow.querySelectorAll('input[type="checkbox"]')).filter(isPrescriptionConfirmCheckbox);
    var canonicalCheckbox =
      confirmRow.querySelector('#la-upload-confirmation') ||
      checkboxes.find(function (input) {
        return input.id !== 'ciw-la-upload-confirmation-fallback';
      }) ||
      checkboxes[0];

    checkboxes.forEach(function (checkbox) {
      if (checkbox === canonicalCheckbox) {
        return;
      }

      var extraRow = findPrescriptionConfirmRowFromCheckbox(checkbox);
      if (extraRow && extraRow !== confirmRow) {
        extraRow.remove();
      } else {
        checkbox.remove();
      }
    });

    var topLabels = Array.from(
      confirmRow.querySelectorAll(':scope > .la-checkox-wrapper-label, :scope > label')
    ).filter(function (node) {
      return node.querySelector('input[type="checkbox"]');
    });

    if (topLabels.length > 1) {
      var keepLabel =
        (canonicalCheckbox && canonicalCheckbox.closest('.la-checkox-wrapper-label, label')) || topLabels[0];
      topLabels.forEach(function (node) {
        if (node !== keepLabel) {
          node.remove();
        }
      });
    }

    var activeLabel = confirmRow.matches('.la-checkox-wrapper-label, label')
      ? confirmRow
      : confirmRow.querySelector('.la-checkox-wrapper-label, label');

    if (activeLabel) {
      if (canonicalCheckbox && !activeLabel.contains(canonicalCheckbox)) {
        activeLabel.insertBefore(canonicalCheckbox, activeLabel.firstChild);
      }

      if (canonicalCheckbox && canonicalCheckbox.id) {
        activeLabel.setAttribute('for', canonicalCheckbox.id);
      }

      var textSpans = activeLabel.querySelectorAll('.ciw-la-manual-rx-confirm-text');
      var textSpan = textSpans[0];

      activeLabel.querySelectorAll('la-translate, .la-checkox-label').forEach(function (node) {
        node.remove();
      });

      textSpans.forEach(function (node, index) {
        if (index > 0) {
          node.remove();
        }
      });

      if (!textSpan) {
        textSpan = document.createElement('span');
        textSpan.className = 'ciw-la-manual-rx-confirm-text';
        activeLabel.appendChild(textSpan);
      }

      if (!String(textSpan.textContent || '').trim()) {
        var chunks = [];
        Array.from(activeLabel.childNodes).forEach(function (node) {
          if (node === canonicalCheckbox || node === textSpan) {
            return;
          }

          var value = String(node.textContent || '').trim();
          if (value) {
            chunks.push(value);
          }
        });

        if (chunks.length) {
          textSpan.textContent = chunks.join(' ').trim();
        }
      }

      stripLensAdvizorConfirmInjection(activeLabel);

      if (!String(textSpan.textContent || '').trim()) {
        textSpan.textContent = getPrescriptionConfirmLabelText();
      }
    }

    confirmRow.classList.remove('la-flex', 'la-form-flex', 'la-column-gap-1-5');
    attachConfirmRowGuard(confirmRow);
  }

  var confirmLabelObservers = typeof WeakMap === 'function' ? new WeakMap() : null;

  function attachConfirmRowGuard(confirmRow) {
    if (!confirmRow || typeof MutationObserver === 'undefined') {
      return;
    }

    if (confirmRow.dataset.ciwLaConfirmGuard === '1') {
      return;
    }

    confirmRow.dataset.ciwLaConfirmGuard = '1';

    var guardLock = false;
    var observer = new MutationObserver(function () {
      if (guardLock) {
        return;
      }

      guardLock = true;
      normalizePrescriptionConfirmRow(confirmRow);
      guardLock = false;
    });

    observer.observe(confirmRow, {
      childList: true,
      subtree: true,
      characterData: true
    });

    if (confirmLabelObservers) {
      confirmLabelObservers.set(confirmRow, observer);
    }
  }

  function runPrescriptionConfirmCleanup(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || isContactLensHost() || form.classList.contains('ciw-la-upload-rx-form--mobile')) {
      return;
    }

    var card = form.querySelector('.ciw-la-manual-rx-card--mobile:not(.ciw-la-upload-rx-card)');
    if (!card) {
      return;
    }

    ensurePrescriptionConfirmInCard(form, card);
  }

  function schedulePrescriptionConfirmCleanup(form) {
    runPrescriptionConfirmCleanup(form);

    window.requestAnimationFrame(function () {
      runPrescriptionConfirmCleanup(form);
    });
  }

  function hasAnyPrescriptionConfirm(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return false;
    }

    return findAllPrescriptionConfirmRows(form).length > 0;
  }

  function buildFallbackPrescriptionConfirmRow(form) {
    form = form || document.querySelector(FORM_SELECTOR);

    var confirmRow = document.createElement('div');
    confirmRow.className = 'ciw-la-manual-rx-confirm-row la-prescription-fields-wrapper';
    confirmRow.dataset.ciwLaFallbackConfirm = '1';

    var label = document.createElement('label');
    label.className = 'la-form-field-label la-checkox-wrapper-label';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.name = 'la-upload-confirmation';
    input.required = true;

    if (!form || !form.querySelector('#la-upload-confirmation')) {
      input.id = 'la-upload-confirmation';
      label.setAttribute('for', 'la-upload-confirmation');
    } else {
      input.id = 'ciw-la-upload-confirmation-fallback';
      label.setAttribute('for', 'ciw-la-upload-confirmation-fallback');
    }

    label.appendChild(input);
    setPrescriptionConfirmLabelText(label, getPrescriptionConfirmLabelText());
    confirmRow.appendChild(label);

    return confirmRow;
  }

  function insertPrescriptionConfirmRowInCard(card, confirmRow) {
    if (!card || !confirmRow || card.contains(confirmRow)) {
      return;
    }

    var commentSection = card.querySelector('.ciw-la-manual-rx-section--comment');
    if (commentSection) {
      commentSection.insertAdjacentElement('afterend', confirmRow);
    } else {
      card.appendChild(confirmRow);
    }
  }

  function ensureFallbackPrescriptionConfirm(form, card) {
    if (!form || !card || isContactLensHost()) {
      return false;
    }

    if (
      hasAnyPrescriptionConfirm(form) ||
      findPrescriptionConfirmCheckbox(form) ||
      form.querySelector('#la-upload-confirmation, #ciw-la-upload-confirmation-fallback, input[name="la-upload-confirmation"]')
    ) {
      return ensurePrescriptionConfirmInCard(form, card);
    }

    var confirmRow = card.querySelector('[data-ciw-la-fallback-confirm]');
    if (!confirmRow) {
      confirmRow = buildFallbackPrescriptionConfirmRow(form);
      insertPrescriptionConfirmRowInCard(card, confirmRow);
    } else {
      syncFallbackPrescriptionConfirmLabel(confirmRow);
    }

    revealPrescriptionConfirmRow(confirmRow);
    refreshManualFooterInset();
    dedupePrescriptionConfirmRows(form, card);
    hideNativeConfirmInsideUploadWrapper(form, card);
    return true;
  }

  function revealPrescriptionConfirmRow(confirmRow) {
    if (!confirmRow) {
      return;
    }

    confirmRow.classList.add('ciw-la-manual-rx-confirm-row');
    confirmRow.classList.remove('ciw-la-manual-rx-hidden');
    confirmRow.style.removeProperty('display');
    confirmRow.style.removeProperty('visibility');
    confirmRow.style.removeProperty('opacity');

    confirmRow.querySelectorAll('.la-checkox-wrapper-label, label, input[type="checkbox"]').forEach(function (node) {
      if (node.classList.contains('ciw-la-upload-rx-hidden-confirm')) {
        return;
      }

      node.classList.remove('ciw-la-manual-rx-hidden');
      node.style.removeProperty('display');
      node.style.removeProperty('visibility');
    });
  }

  function hideUploadWrapperConfirmNode(node) {
    if (!node) {
      return;
    }

    node.classList.remove('ciw-la-manual-rx-confirm-row');
    node.classList.add('ciw-la-manual-rx-hidden', 'ciw-la-upload-rx-hidden-confirm');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('opacity', '0', 'important');
    node.style.setProperty('height', '0', 'important');
    node.style.setProperty('overflow', 'hidden', 'important');
    node.style.setProperty('pointer-events', 'none', 'important');
  }

  function dedupePrescriptionConfirmRows(form, card) {
    if (!form) {
      return;
    }

    card = card || form.querySelector('.ciw-la-manual-rx-card--mobile');
    var picked = pickCanonicalPrescriptionConfirm(form, card);
    var canonical = picked.checkbox;
    var canonicalRow = picked.row;
    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    var isUploadStep = form.classList.contains('ciw-la-upload-rx-form--mobile');

    picked.candidates.forEach(function (entry) {
      var row = entry.row;

      if (canonical && (row === canonicalRow || row.contains(canonical))) {
        return;
      }

      if (row.dataset.ciwLaFallbackConfirm === '1') {
        row.remove();
        return;
      }

      if (uploadWrapper && uploadWrapper.contains(row)) {
        hideUploadWrapperConfirmNode(row);
        return;
      }

      if (isUploadStep && card && card.contains(row)) {
        row.remove();
        return;
      }

      if (card && card.contains(row)) {
        row.remove();
      } else {
        hideElement(row);
      }
    });

    if (isUploadStep && card && canonicalRow) {
      card.querySelectorAll(
        ':scope > .ciw-la-manual-rx-confirm-row, :scope > .la-prescription-fields-wrapper'
      ).forEach(function (row) {
        if (row === canonicalRow || row.contains(canonicalRow) || canonicalRow.contains(row)) {
          return;
        }

        if (row.querySelector('input[type="checkbox"]') && isConfirmOnlyWrapper(row)) {
          row.remove();
        }
      });
    }

    if (canonicalRow) {
      normalizePrescriptionConfirmRow(canonicalRow);
    }

    hideNativeConfirmInsideUploadWrapper(form, card);
  }

  function hideNativeConfirmInsideUploadWrapper(form, card) {
    if (!form) {
      return;
    }

    card = card || form.querySelector('.ciw-la-manual-rx-card--mobile');
    var uploadWrapper = form.querySelector('.la-upload-wrapper');
    if (!uploadWrapper) {
      return;
    }

    var isUploadStep = form.classList.contains('ciw-la-upload-rx-form--mobile');
    var picked = pickCanonicalPrescriptionConfirm(form, card);
    var canonical = picked.checkbox;
    var canonicalRow = picked.row;
    var confirmMovedOut =
      isUploadStep ||
      (canonical &&
        card &&
        card.contains(canonical) &&
        !uploadWrapper.contains(canonical));

    if (!confirmMovedOut) {
      return;
    }

    uploadWrapper.querySelectorAll('.ciw-la-manual-rx-confirm-row, .la-prescription-fields-wrapper, .la-checkox-wrapper-label, label').forEach(function (node) {
      var checkbox = node.matches('input[type="checkbox"]')
        ? node
        : node.querySelector('input[type="checkbox"]');
      if (!checkbox || !isPrescriptionConfirmCheckbox(checkbox)) {
        return;
      }

      hideUploadWrapperConfirmNode(node);
    });

    uploadWrapper.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
      if (!isPrescriptionConfirmCheckbox(checkbox)) {
        return;
      }

      hideUploadWrapperConfirmNode(findPrescriptionConfirmRowFromCheckbox(checkbox) || checkbox);
    });

    uploadWrapper.querySelectorAll('.la-prescription-fields-wrapper').forEach(function (wrapper) {
      if (
        isConfirmOnlyWrapper(wrapper) ||
        (wrapper.querySelector('input[type="checkbox"]') && !wrapper.querySelector('select, input[type="file"], textarea'))
      ) {
        hideUploadWrapperConfirmNode(wrapper);
      }
    });
  }

  function ensurePrescriptionConfirmInCard(form, card) {
    if (!form || !card) {
      return false;
    }

    if (isContactLensHost()) {
      return false;
    }

    var confirmRow = findPrescriptionConfirmRow(form);
    if (!confirmRow) {
      return ensureFallbackPrescriptionConfirm(form, card);
    }

    revealPrescriptionConfirmRow(confirmRow);
    syncPrescriptionConfirmLabel(confirmRow);
    normalizePrescriptionConfirmRow(confirmRow);

    if (!card.contains(confirmRow)) {
      confirmRow.querySelectorAll('.la-divider').forEach(hideElement);
      insertPrescriptionConfirmRowInCard(card, confirmRow);
    }

    dedupePrescriptionConfirmRows(form, card);
    hideNativeConfirmInsideUploadWrapper(form, card);
    refreshManualFooterInset();
    return true;
  }

  function extractConfirmFromUploadWrapper(form, card) {
    var uploadWrapper = form && form.querySelector('.la-upload-wrapper');
    if (!uploadWrapper) {
      return null;
    }

    var checkbox =
      uploadWrapper.querySelector('#la-upload-confirmation') ||
      Array.from(uploadWrapper.querySelectorAll('input[type="checkbox"]')).find(function (input) {
        return !isCustomManualRxCheckbox(input);
      });

    if (!checkbox) {
      return null;
    }

    var confirmRow = findPrescriptionConfirmRowFromCheckbox(checkbox);
    if (!confirmRow || !uploadWrapper.contains(confirmRow)) {
      return null;
    }

    revealPrescriptionConfirmRow(confirmRow);

    if (card) {
      insertPrescriptionConfirmRowInCard(card, confirmRow);
    } else if (uploadWrapper.contains(confirmRow)) {
      form.appendChild(confirmRow);
    }

    hideNativeConfirmInsideUploadWrapper(form, card);
    return confirmRow;
  }

  function hideUploadWrapperPreservingConfirm(form) {
    var uploadWrapper = form && form.querySelector('.la-upload-wrapper');
    if (!uploadWrapper) {
      return;
    }

    var card = form.querySelector('.ciw-la-manual-rx-card--mobile');
    if (card) {
      ensurePrescriptionConfirmInCard(form, card);
    }

    if (!isConfirmInCard(form, card)) {
      extractConfirmFromUploadWrapper(form, card);
      if (card) {
        ensurePrescriptionConfirmInCard(form, card);
      } else {
        var confirmRow = findPrescriptionConfirmRow(form);
        if (confirmRow && uploadWrapper.contains(confirmRow)) {
          revealPrescriptionConfirmRow(confirmRow);
          form.appendChild(confirmRow);
        }
      }
    }

    hideElement(uploadWrapper);
  }

  var confirmWatchers = typeof WeakMap === 'function' ? new WeakMap() : null;

  function stopConfirmWatch(form) {
    if (!confirmWatchers || !form) {
      return;
    }

    var state = confirmWatchers.get(form);
    if (!state) {
      return;
    }

    if (state.observer) {
      state.observer.disconnect();
    }

    state.timeouts.forEach(function (timeoutId) {
      window.clearTimeout(timeoutId);
    });

    confirmWatchers.delete(form);
  }

  function scheduleConfirmInCard(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return;
    }

    if (isContactLensHost()) {
      return;
    }

    var card = form.querySelector('.ciw-la-manual-rx-card--mobile');
    if (!card) {
      return;
    }

    if (ensurePrescriptionConfirmInCard(form, card)) {
      stopConfirmWatch(form);
      delete form.dataset.ciwLaConfirmWatch;
      return;
    }

    if (confirmWatchers && confirmWatchers.get(form)) {
      stopConfirmWatch(form);
    }

    form.dataset.ciwLaConfirmWatch = '1';

    var state = {
      observer: null,
      timeouts: []
    };

    var run = function () {
      var activeCard = form.querySelector('.ciw-la-manual-rx-card--mobile');
      if (!activeCard) {
        return false;
      }

      extractConfirmFromUploadWrapper(form, activeCard);
      if (ensurePrescriptionConfirmInCard(form, activeCard)) {
        return true;
      }

      return ensureFallbackPrescriptionConfirm(form, activeCard);
    };

    [0, 150, 400, 800, 1500, 2500, 4000, 6000, 8000, 10000, 12000].forEach(function (delay) {
      state.timeouts.push(
        window.setTimeout(function () {
          if (run()) {
            stopConfirmWatch(form);
            delete form.dataset.ciwLaConfirmWatch;
          }
        }, delay)
      );
    });

    if (typeof MutationObserver === 'function') {
      state.observer = new MutationObserver(function () {
        if (run()) {
          stopConfirmWatch(form);
          delete form.dataset.ciwLaConfirmWatch;
        }
      });

      state.observer.observe(form, {
        childList: true,
        subtree: true
      });

      state.timeouts.push(
        window.setTimeout(function () {
          stopConfirmWatch(form);
          delete form.dataset.ciwLaConfirmWatch;
        }, 12000)
      );
    }

    confirmWatchers.set(form, state);
  }

  function ensureCommentSectionInCard(form, card) {
    if (!form || !card || card.querySelector('.ciw-la-manual-rx-section--comment')) {
      return;
    }

    hideNativeCommentWrappers(form);

    var section = buildCommentSection(form);
    var confirmRow =
      card.querySelector('.ciw-la-manual-rx-confirm-row') || findPrescriptionConfirmRow(form);

    if (confirmRow && card.contains(confirmRow)) {
      card.insertBefore(section, confirmRow);
    } else {
      card.appendChild(section);
    }
  }

  function ensureManualRxCardTail(form, card) {
    if (!form || !card || isContactLensHost()) {
      return;
    }

    hideUploadWrapperPreservingConfirm(form);
    ensureCommentSectionInCard(form, card);
    hideNativeCommentWrappers(form);
    ensurePrescriptionConfirmInCard(form, card);
    scheduleConfirmInCard(form);
  }

  function updateCommentToggleLabel(toggle, open) {
    if (!toggle) {
      return;
    }

    var plus = toggle.querySelector('.ciw-la-manual-rx-comment__plus');
    var label = toggle.querySelector('.ciw-la-manual-rx-comment__label');
    if (plus) {
      plus.textContent = open ? '\u2212' : '+';
    }
    if (label) {
      label.textContent = open ? 'Hide comment' : 'Add comment';
    }
  }

  function refreshManualFooterInset() {
    var footer = document.querySelector('.la-prescription-modal-footer');
    if (!footer) {
      return;
    }

    window.requestAnimationFrame(function () {
      var height = Math.ceil(footer.getBoundingClientRect().height);
      if (height > 0) {
        document.documentElement.style.setProperty('--ciw-la-footer-h', height + 'px');
      }
    });
  }

  function setCommentPanelOpen(section, open) {
    if (!section) {
      return;
    }

    var toggle = section.querySelector('.ciw-la-manual-rx-comment__toggle');
    var panel = section.querySelector('.ciw-la-manual-rx-comment__panel');
    if (!toggle || !panel) {
      return;
    }

    section.classList.toggle('ciw-la-manual-rx-section--comment-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.hidden = false;
    updateCommentToggleLabel(toggle, open);
    panel.hidden = !open;
    panel.classList.toggle('ciw-la-manual-rx-hidden', !open);

    if (open) {
      var textarea = panel.querySelector('.ciw-la-manual-rx-comment__textarea');
      if (textarea) {
        window.requestAnimationFrame(function () {
          textarea.focus();
        });
      }
    }

    refreshManualFooterInset();
  }

  function buildCommentSection(form) {
    var section = document.createElement('div');
    section.className = 'ciw-la-manual-rx-section ciw-la-manual-rx-section--comment';

    var nativeField = findNativeCommentField(form);
    if (nativeField) {
      hideElement(nativeField.closest('.la-order-notes-wrapper') || nativeField);
    }

    var hiddenNotesField = nativeField ? null : ensureHiddenNotesField(form);
    var syncTarget = nativeField || hiddenNotesField;
    var initialValue = getStoredCommentValue(form);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ciw-la-manual-rx-comment__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    var plus = document.createElement('span');
    plus.className = 'ciw-la-manual-rx-comment__plus';
    plus.textContent = '+';
    var label = document.createElement('span');
    label.className = 'ciw-la-manual-rx-comment__label';
    label.textContent = 'Add comment';
    toggle.appendChild(plus);
    toggle.appendChild(document.createTextNode(' '));
    toggle.appendChild(label);

    var panel = document.createElement('div');
    panel.className = 'ciw-la-manual-rx-comment__panel';
    panel.hidden = true;

    var textarea = document.createElement('textarea');
    textarea.className = 'ciw-la-manual-rx-comment__textarea';
    textarea.setAttribute('rows', '3');
    textarea.setAttribute('aria-label', 'Comment');
    textarea.setAttribute('autocomplete', 'off');
    textarea.setAttribute('maxlength', '500');
    textarea.placeholder = 'Any notes for our team?';

    function syncCommentValue(value) {
      syncCommentToLensAdvizor(value);
      syncCommentToNativeField(syncTarget, value);
    }

    toggle.addEventListener('click', function () {
      var isOpen = section.classList.contains('ciw-la-manual-rx-section--comment-open');
      setCommentPanelOpen(section, !isOpen);
    });

    textarea.addEventListener('input', function () {
      syncCommentValue(textarea.value);
    });

    if (initialValue) {
      textarea.value = initialValue;
      syncCommentValue(initialValue);
      setCommentPanelOpen(section, true);
    }

    panel.appendChild(textarea);
    section.appendChild(toggle);
    section.appendChild(panel);

    return section;
  }

  function syncCommentToReviewField() {
    var la = window.LensAdvizor;
    var value = la && la.response && typeof la.response.orderNote === 'string' ? la.response.orderNote : '';
    if (!value) {
      return;
    }

    var reviewNotes = document.querySelector('#la-order-notes');
    if (reviewNotes && reviewNotes.value !== value) {
      syncCommentToNativeField(reviewNotes, value);
    }
  }

  function isDualPdEnabled(pdContainer) {
    var dualCheckbox = pdContainer && pdContainer.querySelector('.ciw-la-manual-rx-dual-pd .ciw-la-manual-rx-checkbox__input');
    if (dualCheckbox) {
      return dualCheckbox.checked;
    }

    var dualRadio = pdContainer && pdContainer.querySelector('#la-pd-field-dual');
    return !!(dualRadio && dualRadio.checked);
  }

  function getSinglePdSelect(pdFields) {
    if (!pdFields) {
      return null;
    }

    var splitSelect = pdFields.querySelector(
      '.ciw-la-pd-split:not(.ciw-la-pd-split--dual) .ciw-la-pd-split__field select'
    );
    if (splitSelect) {
      return splitSelect;
    }

    return getNativeSinglePdSelect(pdFields);
  }

  function getNativeSinglePdSelect(pdFields) {
    if (!pdFields) {
      return null;
    }

    var items = pdFields.querySelectorAll('.la-form-item');
    for (var i = 0; i < items.length; i++) {
      var itemSelect = items[i].querySelector('select');
      if (itemSelect) {
        return itemSelect;
      }
    }

    var looseSelects = Array.from(pdFields.querySelectorAll('select')).filter(function (select) {
      return !select.closest('.ciw-la-pd-split');
    });

    if (looseSelects.length === 1) {
      return looseSelects[0];
    }

    return looseSelects[0] || null;
  }

  function restorePdFormItems(pdFields) {
    if (!pdFields) {
      return;
    }

    pdFields.querySelectorAll('.la-form-item').forEach(function (item) {
      item.classList.remove('ciw-la-manual-rx-hidden');
    });
  }

  function removeCustomPdSplits(pdFields) {
    if (!pdFields) {
      return;
    }

    pdFields.querySelectorAll('.ciw-la-pd-split').forEach(function (node) {
      node.remove();
    });
  }

  function setPdFieldsPending(pdFields) {
    if (!pdFields) {
      return;
    }

    pdFields.classList.add('ciw-la-manual-rx-pd-fields--pending');
    pdFields.classList.remove('ciw-la-manual-rx-pd-fields--ready');
  }

  function finalizePdFieldsState(pdFields) {
    if (!pdFields) {
      return;
    }

    if (pdFields.querySelector('.ciw-la-pd-split')) {
      pdFields.classList.remove('ciw-la-manual-rx-pd-fields--pending');
      pdFields.classList.add('ciw-la-manual-rx-pd-fields--ready');
      return;
    }

    setPdFieldsPending(pdFields);
  }

  function isPdSelectEmpty(select) {
    if (!select) {
      return true;
    }

    var value = String(select.value || '').trim();
    if (!value) {
      return true;
    }

    var label = '';
    if (select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
      label = String(select.options[select.selectedIndex].textContent || '').trim();
    }

    return value === 'Choose' || label === 'Choose' || label === 'Select';
  }

  function getPdOptionNumber(option) {
    if (!option) {
      return NaN;
    }

    var raw = String(option.value || option.textContent || '').trim();
    if (!raw || raw === 'Choose' || raw === 'Select') {
      return NaN;
    }

    return parseFloat(raw);
  }

  function findDefaultPdOption(select, targetPd) {
    if (!select) {
      return null;
    }

    var target = typeof targetPd === 'number' ? targetPd : 62;

    return Array.from(select.options).find(function (option) {
      return getPdOptionNumber(option) === target;
    }) || null;
  }

  function setSelectValue(select, value) {
    if (!select) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(select, value);
    } else {
      select.value = value;
    }

    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function presetDefaultPd(pdFields, pdContainer) {
    if (!pdFields || isDualPdEnabled(pdContainer || pdFields.closest('.ciw-la-manual-rx-section--pd'))) {
      return false;
    }

    var select = getSinglePdSelect(pdFields);
    if (!select) {
      return false;
    }

    if (select.dataset.ciwPdPreset === '1') {
      if (!isPdSelectEmpty(select)) {
        return true;
      }

      delete select.dataset.ciwPdPreset;
    }

    if (!isPdSelectEmpty(select)) {
      select.dataset.ciwPdPreset = '1';
      return true;
    }

    var match = findDefaultPdOption(select);
    if (!match) {
      return false;
    }

    setSelectValue(select, match.value);
    if (!isPdSelectEmpty(select)) {
      select.dataset.ciwPdPreset = '1';
      return true;
    }

    return false;
  }

  function getDualPdSelects(pdFields) {
    if (!pdFields) {
      return { right: null, left: null };
    }

    var right = pdFields.querySelector('select[data-field="right"], select[name="la-pd-right"]');
    var left = pdFields.querySelector('select[data-field="left"], select[name="la-pd-left"]');
    if (right && left) {
      return { right: right, left: left };
    }

    var selects = pdFields.querySelectorAll('.la-form-item select');
    return {
      right: selects[0] || null,
      left: selects[1] || null
    };
  }

  function presetDefaultDualPd(pdFields, pdContainer) {
    if (!pdFields || !isDualPdEnabled(pdContainer || pdFields.closest('.ciw-la-manual-rx-section--pd'))) {
      return false;
    }

    var selects = getDualPdSelects(pdFields);
    if (!selects.right || !selects.left) {
      return false;
    }

    var allSet = true;

    [selects.right, selects.left].forEach(function (select) {
      if (select.dataset.ciwPdPreset === '1') {
        if (!isPdSelectEmpty(select)) {
          return;
        }

        delete select.dataset.ciwPdPreset;
      }

      if (!isPdSelectEmpty(select)) {
        select.dataset.ciwPdPreset = '1';
        return;
      }

      var match = findDefaultPdOption(select, 31);
      if (!match) {
        allSet = false;
        return;
      }

      setSelectValue(select, match.value);
      if (!isPdSelectEmpty(select)) {
        select.dataset.ciwPdPreset = '1';
      } else {
        allSet = false;
      }
    });

    return allSet;
  }

  function buildPdLabelCell(helpTarget) {
      var label = document.createElement('div');
    label.className = 'ciw-la-pd-split__label';

    var labelText = document.createElement('span');
    labelText.className = 'ciw-la-pd-split__label-text';
    labelText.textContent = 'PD';

    var helpBtn = document.createElement('button');
    helpBtn.type = 'button';
    helpBtn.className = 'ciw-la-rx-help-trigger__icon ciw-la-pd-help-trigger';
    helpBtn.setAttribute('data-ciw-la-rx-read-help-open', '');
    helpBtn.setAttribute('data-ciw-la-rx-read-help-target', helpTarget || 'ciw-la-rx-read-help-pd');
    helpBtn.setAttribute('aria-label', 'How to read PD on your prescription');
    helpBtn.innerHTML = '<span aria-hidden="true">?</span>';

    label.appendChild(labelText);
    label.appendChild(helpBtn);

    return label;
  }

  function hideEmptyPdFormItems(pdFields) {
    if (!pdFields) {
      return;
    }

    pdFields.querySelectorAll('.la-form-item').forEach(function (item) {
      if (!item.querySelector('select')) {
        hideElement(item);
      }
    });
  }

  function dualPdSplitIsValid(split, pdFields) {
    if (!split || !pdFields) {
      return false;
    }

    var selects = getDualPdSelects(pdFields);
    return !!(
      selects.right &&
      selects.left &&
      split.contains(selects.right) &&
      split.contains(selects.left)
    );
  }

  function singlePdSplitIsValid(split, pdFields) {
    if (!split || !pdFields) {
      return false;
    }

    var select = getSinglePdSelect(pdFields);
    return !!(select && split.contains(select));
  }

  function animatePdSplitExpand(split) {
    if (!split) {
      return;
    }

    split.classList.add('ciw-la-pd-split--expand-from-single');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        split.classList.remove('ciw-la-pd-split--expand-from-single');
      });
    });
  }

  function updatePdHelpTarget(split, helpTarget) {
    if (!split) {
      return;
    }

    var helpBtn = split.querySelector('.ciw-la-pd-help-trigger');
    if (helpBtn) {
      helpBtn.setAttribute('data-ciw-la-rx-read-help-target', helpTarget);
    }
  }

  function buildDualPdFields(selects) {
    var fields = document.createElement('div');
    fields.className = 'ciw-la-pd-dual-split__fields';

    [
      { select: selects.right, label: 'Right Eye' },
      { select: selects.left, label: 'Left Eye' }
    ].forEach(function (eye) {
      var item = eye.select.closest('.la-form-item');
      if (item) {
        hideElement(item.querySelector('label'));
      }

      eye.select.setAttribute('aria-label', eye.label);

      var eyeWrap = document.createElement('div');
      eyeWrap.className = 'ciw-la-pd-dual-split__eye';

      var field = document.createElement('div');
      field.className = 'ciw-la-pd-dual-split__field';

      var eyeLabel = document.createElement('span');
      eyeLabel.className = 'ciw-la-pd-dual-split__eye-label';
      eyeLabel.textContent = eye.label;

      field.appendChild(eyeLabel);
      field.appendChild(eye.select);

      eyeWrap.appendChild(field);
      fields.appendChild(eyeWrap);
    });

    return fields;
  }

  function morphSingleSplitToDual(split, selects, pdFields) {
    if (!split || !selects.right || !selects.left) {
      return false;
    }

    var singleField = split.querySelector('.ciw-la-pd-split__field');
    if (!singleField) {
      return false;
    }

    singleField.replaceWith(buildDualPdFields(selects));
    split.classList.add('ciw-la-pd-split--dual', 'ciw-la-pd-split--expand-from-single');
    updatePdHelpTarget(split, 'ciw-la-rx-read-help-2pd');
    hideEmptyPdFormItems(pdFields);
    animatePdSplitExpand(split);
    return true;
  }

  function enhanceDualPdSplitRow(pdFields, pdContainer) {
    var selects = getDualPdSelects(pdFields);
    if (!selects.right || !selects.left) {
      return false;
    }

    var existingSingle = pdFields.querySelector('.ciw-la-pd-split:not(.ciw-la-pd-split--dual)');
    if (existingSingle && morphSingleSplitToDual(existingSingle, selects, pdFields)) {
      return presetDefaultDualPd(pdFields, pdContainer);
    }

    pdFields.querySelectorAll('.ciw-la-pd-split').forEach(function (node) {
      node.remove();
    });

    var split = document.createElement('div');
    split.className = 'ciw-la-pd-split ciw-la-pd-split--dual ciw-la-pd-split--expand-from-single';

    split.appendChild(buildPdLabelCell('ciw-la-rx-read-help-2pd'));
    split.appendChild(buildDualPdFields(selects));

    pdFields.insertBefore(split, pdFields.firstChild);
    hideEmptyPdFormItems(pdFields);
    animatePdSplitExpand(split);

    return presetDefaultDualPd(pdFields, pdContainer);
  }

  function enhanceSinglePdSplitRow(pdFields, pdContainer) {
    if (!pdFields) {
      return false;
    }

    var split = pdFields.querySelector('.ciw-la-pd-split:not(.ciw-la-pd-split--dual)');
    if (split && singlePdSplitIsValid(split, pdFields)) {
      ensurePdHelpTrigger(split);
      return presetDefaultPd(pdFields, pdContainer);
    }

    removeCustomPdSplits(pdFields);
    restorePdFormItems(pdFields);

    var select = getNativeSinglePdSelect(pdFields);
    if (!select) {
      return false;
    }

    var firstItem = select.closest('.la-form-item');

    split = document.createElement('div');
    split.className = 'ciw-la-pd-split';

    split.appendChild(buildPdLabelCell());

    var field = document.createElement('div');
    field.className = 'ciw-la-pd-split__field';

    if (firstItem) {
      hideElement(firstItem.querySelector('label'));
    }

    field.appendChild(select);

    split.appendChild(field);
    pdFields.insertBefore(split, pdFields.firstChild);
    hideEmptyPdFormItems(pdFields);

    return presetDefaultPd(pdFields, pdContainer);
  }

  function hideNativePdFieldSiblings(pdFields) {
    if (!pdFields || !pdFields.querySelector('.ciw-la-pd-split')) {
      return;
    }

    pdFields.querySelectorAll(':scope > *:not(.ciw-la-pd-split)').forEach(hideElement);
  }

  function syncPdLayout(pdFields, pdContainer) {
    if (!pdFields) {
      return false;
    }

    pdContainer = pdContainer || pdFields.closest('.ciw-la-manual-rx-section--pd');
    var dualEnabled = isDualPdEnabled(pdContainer);
    var result = false;

    pdFields.classList.toggle('ciw-la-manual-rx-pd-fields--dual', dualEnabled);

    if (dualEnabled) {
      restorePdFormItems(pdFields);

      var dualSplit = pdFields.querySelector('.ciw-la-pd-split--dual');
      if (dualSplit && dualPdSplitIsValid(dualSplit, pdFields)) {
        ensurePdHelpTrigger(dualSplit);
        result = presetDefaultDualPd(pdFields, pdContainer);
      } else {
        result = enhanceDualPdSplitRow(pdFields, pdContainer);
      }
    } else {
      if (pdFields.querySelector('.ciw-la-pd-split--dual')) {
        removeCustomPdSplits(pdFields);
        restorePdFormItems(pdFields);
      }

      result = enhanceSinglePdSplitRow(pdFields, pdContainer);
    }

    finalizePdFieldsState(pdFields);
    hideNativePdFieldSiblings(pdFields);
    sanitizeManualRxValidation(pdFields && pdFields.closest(FORM_SELECTOR));
    document.dispatchEvent(new CustomEvent('ciw-la-manual-rx:pd-synced'));
    return result;
  }

  function enhancePdSplitRow(pdFields, pdContainer) {
    return syncPdLayout(pdFields, pdContainer);
  }

  function ensurePdHelpTrigger(split) {
    if (!split) {
      return;
    }

    var label = split.querySelector('.ciw-la-pd-split__label');
    if (!label || label.querySelector('.ciw-la-pd-help-trigger')) {
      return;
    }

    var text = label.querySelector('.ciw-la-pd-split__label-text');
    if (!text) {
      text = document.createElement('span');
      text.className = 'ciw-la-pd-split__label-text';
      text.textContent = label.textContent.trim() || 'PD';
      label.textContent = '';
      label.appendChild(text);
    }

    var helpTarget = split.classList.contains('ciw-la-pd-split--dual')
      ? 'ciw-la-rx-read-help-2pd'
      : 'ciw-la-rx-read-help-pd';

    var helpBtn = document.createElement('button');
    helpBtn.type = 'button';
    helpBtn.className = 'ciw-la-rx-help-trigger__icon ciw-la-pd-help-trigger';
    helpBtn.setAttribute('data-ciw-la-rx-read-help-open', '');
    helpBtn.setAttribute('data-ciw-la-rx-read-help-target', helpTarget);
    helpBtn.setAttribute('aria-label', 'How to read PD on your prescription');
    helpBtn.innerHTML = '<span aria-hidden="true">?</span>';
    label.appendChild(helpBtn);
  }

  var pdPresetObservers = typeof WeakMap === 'function' ? new WeakMap() : null;

  function stopPdPresetWatch(pdContainer) {
    if (!pdPresetObservers || !pdContainer) {
      return;
    }

    var state = pdPresetObservers.get(pdContainer);
    if (!state) {
      return;
    }

    if (state.observer) {
      state.observer.disconnect();
    }

    state.timeouts.forEach(function (timeoutId) {
      window.clearTimeout(timeoutId);
    });

    pdPresetObservers.delete(pdContainer);
  }

  function schedulePdPreset(pdContainer) {
    if (!pdContainer) {
      return;
    }

    var pdFields = pdContainer.querySelector('#la-pd-fields-container');
    if (!pdFields) {
      return;
    }

    stopPdPresetWatch(pdContainer);

    var state = {
      observer: null,
      timeouts: []
    };

    var run = function () {
      return syncPdLayout(pdFields, pdContainer);
    };

    [0, 150, 400, 800, 1500, 2500].forEach(function (delay) {
      state.timeouts.push(
        window.setTimeout(function () {
          if (run()) {
            stopPdPresetWatch(pdContainer);
          }
        }, delay)
      );
    });

    if (typeof MutationObserver === 'function') {
      state.observer = new MutationObserver(function () {
        if (pdFields.querySelector('.ciw-la-pd-split--expand-from-single')) {
          return;
        }

        if (run()) {
          stopPdPresetWatch(pdContainer);
        }
      });

      state.observer.observe(pdFields, {
        childList: true,
        subtree: true
      });

      state.timeouts.push(
        window.setTimeout(function () {
          stopPdPresetWatch(pdContainer);
        }, 3000)
      );
    }

    if (pdPresetObservers) {
      pdPresetObservers.set(pdContainer, state);
    }
  }

  function enhancePdSection(pdContainer) {
    pdContainer.classList.add('ciw-la-manual-rx-section', 'ciw-la-manual-rx-section--pd');

    hideElement(pdContainer.querySelector('.ciw-la-manual-rx-section__label'));
    hideElement(pdContainer.querySelector('.la-h6'));

    var radioRow = pdContainer.querySelector('.la-flex.la-column-gap-1-5');
    var dualRadio = pdContainer.querySelector('#la-pd-field-dual');
    var singleRadio = pdContainer.querySelector('#la-pd-field-single');

    if (radioRow && dualRadio && singleRadio && !pdContainer.querySelector('.ciw-la-manual-rx-dual-pd')) {
      hideElement(radioRow);

      singleRadio.checked = true;
      dualRadio.checked = false;
      singleRadio.dispatchEvent(new Event('change', { bubbles: true }));

      var dualCheckbox = createCheckboxRow('I have 2 PD numbers', false, function (checked) {
        var form = pdContainer.closest('form');
        runPrescriptionConfirmCleanup(form);

        var pdFields = pdContainer.querySelector('#la-pd-fields-container');
        setPdFieldsPending(pdFields);

        var target = checked ? dualRadio : singleRadio;
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('click', { bubbles: true }));

        if (pdFields) {
          pdFields.querySelectorAll('select').forEach(function (select) {
            delete select.dataset.ciwPdPreset;
          });
          syncPdLayout(pdFields, pdContainer);
        }

        schedulePdPreset(pdContainer);
        runPrescriptionConfirmCleanup(form);
      });
      dualCheckbox.classList.add('ciw-la-manual-rx-dual-pd');
      pdContainer.appendChild(dualCheckbox);
    }

    var pdFields = pdContainer.querySelector('#la-pd-fields-container');
    if (pdFields) {
      pdFields.classList.add('ciw-la-manual-rx-pd-fields');
      setPdFieldsPending(pdFields);
      schedulePdPreset(pdContainer);
    }
  }

  function getPrismCheckboxLabel() {
    if (window.ciwLaPrismUpgradeApi && typeof window.ciwLaPrismUpgradeApi.getCheckboxLabel === 'function') {
      return window.ciwLaPrismUpgradeApi.getCheckboxLabel();
    }
    return 'Add prism (+$39)';
  }

  function syncPrismUpgradePricing() {
    if (window.ciwLaPrismUpgradeApi && typeof window.ciwLaPrismUpgradeApi.syncPricing === 'function') {
      window.ciwLaPrismUpgradeApi.syncPricing();
    }
  }

  function suppressPrismManualFields(form, prismWrapper) {
    form.querySelectorAll('.ciw-la-prism-stack').forEach(function (node) {
      node.remove();
    });

    if (prismWrapper) {
      prismWrapper.querySelectorAll(':scope > .la-prescription-fields-wrapper').forEach(hideElement);
      prismWrapper.querySelectorAll('.la-prescription-fields-wrapper .la-prescription-fields-wrapper').forEach(hideElement);
      prismWrapper.querySelectorAll('.la-prism-field, .ciw-la-prism-fields, .la-flex.la-column-gap-1-5, .la-form-flex.la-column-gap-1-5').forEach(hideElement);
    }

    form.querySelectorAll('.la-prescription-fields-wrapper').forEach(function (wrapper) {
      if (wrapper.classList.contains('ciw-la-manual-rx-section--prism')) {
        return;
      }

      if (wrapper.querySelector('.la-prism-select, [data-field-name="horizontal"]')) {
        hideElement(wrapper);
      }
    });

    form.querySelectorAll('[data-field-name="horizontal"], .la-prism-select').forEach(function (field) {
      if (field.closest('.ciw-la-prism-upload')) {
        return;
      }

      var item = field.closest('.la-form-item') || field.closest('.la-prescription-fields-wrapper');
        if (item) {
        hideElement(item);
      }
    });

    var outer = getPrismFieldsOuter(prismWrapper) || findPrismFieldsOuterInForm(form);
    if (outer && !outer.classList.contains('ciw-la-manual-rx-section--prism')) {
      hideElement(outer);
    }
  }

  function getPrescriptionFileInput(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return null;
    }

    return form.querySelector('#la-prescription-file');
  }

  function setPrismUploadRequired(required) {
    var fileInput = getPrescriptionFileInput();
    if (!fileInput) {
      return;
    }

    fileInput.required = !!required;
    if (required) {
      fileInput.setAttribute('required', 'required');
    } else {
      fileInput.removeAttribute('required');
    }
  }

  function syncPrismUploadStatus(panel) {
    if (!panel) {
      return;
    }

    var fileInput = getPrescriptionFileInput();
    var status = panel.querySelector('.ciw-la-prism-upload__status');
    var uploadBtn = panel.querySelector('.ciw-la-prism-upload__btn');
    if (!fileInput || !status || !uploadBtn) {
      return;
    }

    if (fileInput.files && fileInput.files[0]) {
      status.textContent = fileInput.files[0].name;
      uploadBtn.textContent = 'Change file';
      panel.classList.remove('ciw-la-prism-upload--error');
    } else {
      status.textContent = '';
      uploadBtn.textContent = 'Upload prescription';
    }
  }

  function bindPrismUploadStatus(panel) {
    if (!panel || panel.dataset.ciwLaPrismUploadBound === '1') {
      return;
    }

    var fileInput = getPrescriptionFileInput();
    if (!fileInput) {
      return;
    }

    panel.dataset.ciwLaPrismUploadBound = '1';
    fileInput.addEventListener('change', function () {
      syncPrismUploadStatus(panel);
    });
    syncPrismUploadStatus(panel);
  }

  function ensurePrismUploadPanel(prismWrapper) {
    var panel = prismWrapper.querySelector('.ciw-la-prism-upload');
    if (panel) {
      bindPrismUploadStatus(panel);
      return panel;
    }

    panel = document.createElement('div');
    panel.className = 'ciw-la-prism-upload';

    var help = document.createElement('p');
    help.className = 'ciw-la-prism-upload__help';
    help.textContent =
      'Upload a clear photo of your prescription that shows prism values. Our team will enter the prism details for you.';

    var uploadBtn = document.createElement('label');
    uploadBtn.className = 'ciw-la-prism-upload__btn';
    uploadBtn.setAttribute('for', 'la-prescription-file');
    uploadBtn.textContent = 'Upload prescription';

    var status = document.createElement('p');
    status.className = 'ciw-la-prism-upload__status';
    status.setAttribute('aria-live', 'polite');

    panel.appendChild(help);
    panel.appendChild(uploadBtn);
    panel.appendChild(status);

    var toggle = prismWrapper.querySelector('.ciw-la-manual-rx-prism-toggle');
    if (toggle) {
      toggle.insertAdjacentElement('afterend', panel);
    } else {
      prismWrapper.appendChild(panel);
    }

    bindPrismUploadStatus(panel);
    return panel;
  }

  function teardownPrismUpload(form) {
    setPrismUploadRequired(false);

    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return;
    }

    form.querySelectorAll('.ciw-la-prism-upload').forEach(function (panel) {
      panel.classList.add('ciw-la-manual-rx-hidden');
    });
  }

  function getPrismFieldsOuter(prismWrapper) {
    if (!prismWrapper) {
      return null;
    }

    return Array.from(
      prismWrapper.querySelectorAll(':scope > .la-prescription-fields-wrapper')
    ).find(function (wrapper) {
      return wrapper.querySelector(':scope > .la-prescription-fields-wrapper .la-form-flex');
    });
  }

  function findPrismFieldsOuterInForm(form) {
    if (!form) {
      return null;
    }

    return Array.from(form.querySelectorAll('.la-prescription-fields-wrapper')).find(function (wrapper) {
      return Array.from(wrapper.querySelectorAll(':scope > .la-prescription-fields-wrapper')).some(function (eyeWrapper) {
        return eyeWrapper.querySelector('.la-prism-select, [data-field-name="horizontal"]');
      });
    });
  }

  function findPrismSectionWrapper(form) {
    if (!form) {
      return null;
    }

    var inCard = form.querySelector('.ciw-la-manual-rx-section--prism');
    if (inCard) {
      return inCard;
    }

    var radio = form.querySelector('#la-prism-field-dual, #la-prism-field-single');
    return radio ? radio.closest('.la-prescription-fields-wrapper') : null;
  }

  function getEyeWrappers(outer) {
    if (!outer) {
      return [];
    }

    return Array.from(
      outer.querySelectorAll(':scope > .la-prescription-fields-wrapper')
    ).filter(function (wrapper) {
      return wrapper.querySelector('.la-form-flex');
    });
  }

  function isPrismFieldsContainer(el) {
    if (!el || !el.classList.contains('la-prescription-fields-wrapper')) {
      return false;
    }

    if (el.classList.contains('ciw-la-prism-fields')) {
      return true;
    }

    return getEyeWrappers(el).some(function (wrapper) {
      return wrapper.querySelector('.la-prism-select, [data-field-name="horizontal"]');
    });
  }

  function isPrismEnabled(form) {
    if (!form) {
      return false;
    }

    var toggle = form.querySelector(
      '.ciw-la-manual-rx-prism-toggle .ciw-la-manual-rx-checkbox__input'
    );
    if (toggle) {
      return toggle.checked;
    }

    var yesRadio = form.querySelector('#la-prism-field-dual');
    return !!(yesRadio && yesRadio.checked);
  }

  function teardownPrismEnhancement(form) {
    if (!form) {
      return;
    }

    teardownPrismUpload(form);

    form.querySelectorAll('.ciw-la-prism-stack').forEach(function (node) {
      node.remove();
    });

    var prismSection = findPrismSectionWrapper(form);
    if (prismSection) {
      suppressPrismManualFields(form, prismSection);
    }
  }

  function enhancePrismFieldsContent(prismWrapper, form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return;
    }

    if (!isPrismEnabled(form)) {
      teardownPrismEnhancement(form);
      return;
    }

    prismWrapper = findPrismSectionWrapper(form) || prismWrapper;
    if (!prismWrapper) {
      return;
    }

    suppressPrismManualFields(form, prismWrapper);

    var panel = ensurePrismUploadPanel(prismWrapper);
    panel.classList.remove('ciw-la-manual-rx-hidden');
    setPrismUploadRequired(true);
    syncPrismUploadStatus(panel);
  }

  function enhancePrismSection(prismWrapper) {
    var form = document.querySelector(FORM_SELECTOR);

    prismWrapper.classList.add('ciw-la-manual-rx-section', 'ciw-la-manual-rx-section--prism');
    prismWrapper.classList.remove('ciw-la-prism-native-pending');

    if (!prismWrapper.querySelector('.ciw-la-manual-rx-section__label')) {
      var label = document.createElement('div');
      label.className = 'ciw-la-manual-rx-section__label';
      label.textContent = 'Prism';
      prismWrapper.insertBefore(label, prismWrapper.firstChild);
    }

    hideElement(prismWrapper.querySelector('.la-h6'));

    var radioRow = prismWrapper.querySelector('.la-flex.la-column-gap-1-5');
    var yesRadio = prismWrapper.querySelector('#la-prism-field-dual');
    var noRadio = prismWrapper.querySelector('#la-prism-field-single');

    if (radioRow && yesRadio && noRadio && !prismWrapper.querySelector('.ciw-la-manual-rx-prism-toggle')) {
      hideElement(radioRow);

      noRadio.checked = true;
      yesRadio.checked = false;
      noRadio.dispatchEvent(new Event('change', { bubbles: true }));

      var prismCheckbox = createCheckboxRow(getPrismCheckboxLabel(), false, function (checked) {
        runPrescriptionConfirmCleanup(form);

        if (!checked) {
          teardownPrismEnhancement(form);
        }

        var target = checked ? yesRadio : noRadio;
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('click', { bubbles: true }));
        suppressPrismManualFields(form, prismWrapper);
        runPrismGuard(form);
        schedulePrismEnhance();
        syncPrismUpgradePricing();
        runPrescriptionConfirmCleanup(form);
      });
      prismCheckbox.classList.add('ciw-la-manual-rx-prism-toggle');
      prismWrapper.appendChild(prismCheckbox);
    }

    var existingPrismLabel = prismWrapper.querySelector(
      '.ciw-la-manual-rx-prism-toggle .ciw-la-manual-rx-checkbox__label'
    );
    if (existingPrismLabel) {
      existingPrismLabel.textContent = getPrismCheckboxLabel();
    }

    suppressPrismManualFields(form, prismWrapper);
    enhancePrismFieldsContent(prismWrapper, form);
    syncPrismUpgradePricing();
  }

  function reEnhancePrism() {
    var form = document.querySelector(FORM_SELECTOR);
    if (!form || !form.querySelector(ENHANCED_MARKER)) {
      return;
    }

    var prismWrapper = findPrismSectionWrapper(form);
    if (!prismWrapper) {
      return;
    }

    enhancePrismSection(prismWrapper);
  }

  function markNativePrismPending(form) {
    form = form || document.querySelector(FORM_SELECTOR);
    if (!form || !form.querySelector('.la-right-rx-container')) {
      return;
    }

    form.querySelectorAll('.la-prescription-fields-wrapper').forEach(function (wrapper) {
      if (wrapper.classList.contains('ciw-la-manual-rx-section--prism')) {
        wrapper.classList.remove('ciw-la-prism-native-pending');
        return;
      }

      if (
        wrapper.querySelector(
          '#la-prism-field-dual, #la-prism-field-single, .la-prism-select, [data-field-name="horizontal"]'
        )
      ) {
        wrapper.classList.add('ciw-la-prism-native-pending');
      }
    });

    form.querySelectorAll('.ciw-la-prism-stack, .la-prism-field').forEach(function (node) {
      if (!node.closest('.ciw-la-manual-rx-section--prism')) {
        node.classList.add('ciw-la-prism-native-pending');
      }
    });
  }

  function runPrismGuard(form) {
    if (!document.querySelector('.ciw-pdp')) {
      return;
    }

    form = form || document.querySelector(FORM_SELECTOR);
    if (!form) {
      return;
    }

    markNativePrismPending(form);
    suppressPrismManualFields(form, findPrismSectionWrapper(form));
  }

  var prismEnhanceTimer = null;

  function schedulePrismEnhance() {
    runPrismGuard();

    if (prismEnhanceTimer) {
      window.clearTimeout(prismEnhanceTimer);
    }

    prismEnhanceTimer = window.setTimeout(function () {
      prismEnhanceTimer = null;
      reEnhancePrism();
      sanitizeManualRxValidation();
      window.setTimeout(reEnhancePrism, 0);
      window.setTimeout(reEnhancePrism, 150);
      window.setTimeout(reEnhancePrism, 400);
      window.setTimeout(reEnhancePrism, 700);
    }, 0);
  }

  function bindPrismObserver(form) {
    if (!form || form.dataset.ciwLaPrismObserved === '1') {
      return;
    }

    form.dataset.ciwLaPrismObserved = '1';

    var observer = new MutationObserver(function () {
      runPrismGuard(form);
      schedulePrismEnhance();
    });

    observer.observe(form, { childList: true, subtree: true });
  }

  var manualFooterWatch = null;
  var manualFooterResizeObserver = null;

  function bindManualFooterResize(footer) {
    if (!footer || manualFooterResizeObserver || typeof ResizeObserver === 'undefined') {
      return;
    }

    manualFooterResizeObserver = new ResizeObserver(function () {
      refreshManualFooterInset();
    });
    manualFooterResizeObserver.observe(footer);
  }

  function updateManualFooterInset(footer) {
    if (!footer) return;
    var height = Math.ceil(footer.getBoundingClientRect().height);
    if (height > 0) {
      document.documentElement.style.setProperty('--ciw-la-footer-h', height + 'px');
    }
  }

  function revealManualFooterButton(footer) {
    if (!footer) return;
    var buttonWrap = footer.querySelector('.la-subtotal-footer-button');
    if (!buttonWrap) return;

    buttonWrap.removeAttribute('hidden');
    buttonWrap.style.removeProperty('display');
    buttonWrap.style.removeProperty('height');
    buttonWrap.style.removeProperty('max-height');
    buttonWrap.style.removeProperty('min-height');
    buttonWrap.style.removeProperty('overflow');

    var btn = buttonWrap.querySelector('.la-prescription-form-btn');
    if (!btn) return;

    btn.style.removeProperty('display');
    btn.style.removeProperty('height');
    btn.style.removeProperty('max-height');
    btn.style.removeProperty('min-height');
    btn.style.removeProperty('overflow');
    buttonWrap.style.setProperty('display', 'block', 'important');
    buttonWrap.style.setProperty('height', 'auto', 'important');
    buttonWrap.style.setProperty('max-height', 'none', 'important');
    buttonWrap.style.setProperty('overflow', 'visible', 'important');
    btn.style.setProperty('display', 'block', 'important');
    btn.style.setProperty('height', 'auto', 'important');
    btn.style.setProperty('max-height', 'none', 'important');
    btn.style.setProperty('overflow', 'visible', 'important');
  }

  function ensureMobileManualFooter() {
    if (!isMobileRx() || !document.body.classList.contains('la-modal-open')) return;
    if (isContactLensFormStep()) return;

    var form = document.querySelector(FORM_SELECTOR);
    if (!form) {
      return;
    }

    var isManualStep =
      form.querySelector('.la-right-rx-container') && form.querySelector('.la-left-rx-container');
    var isUploadStep = form.classList.contains('ciw-la-upload-rx-form--mobile');
    if (!isManualStep && !isUploadStep) {
      return;
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    var wrapper = document.querySelector('.la-prescription-modal-wrapper');
    var footer = document.querySelector('.la-prescription-modal-footer');
    if (!modal || !footer) return;

    if (
      isUploadStep &&
      form.classList.contains('ciw-la-upload-rx--ready') &&
      footer.dataset.ciwLaUploadFooterReady === '1'
    ) {
      refreshManualFooterInset();
      return;
    }

    if (wrapper) {
      wrapper.classList.add('ciw-la-flow-step', 'ciw-la-review-footer-active');
    }

    if (footer.parentElement !== modal) {
      modal.appendChild(footer);
    }

    footer.classList.add(
      'ciw-la-review-footer--pinned',
      'ciw-la-subtotal-footer--show-action'
    );

    revealManualFooterButton(footer);
    updateManualFooterInset(footer);
    refreshManualFooterInset();
    bindManualFooterResize(footer);

    if (isUploadStep) {
      footer.dataset.ciwLaUploadFooterReady = '1';
    }
  }

  function stopManualFooterWatch() {
    if (!manualFooterWatch) {
      if (manualFooterResizeObserver) {
        manualFooterResizeObserver.disconnect();
        manualFooterResizeObserver = null;
      }
      var idleFooter = document.querySelector('.la-prescription-modal-footer');
      if (idleFooter) {
        delete idleFooter.dataset.ciwLaUploadFooterReady;
      }
      return;
    }
    window.clearInterval(manualFooterWatch);
    manualFooterWatch = null;
    if (manualFooterResizeObserver) {
      manualFooterResizeObserver.disconnect();
      manualFooterResizeObserver = null;
    }
    var footer = document.querySelector('.la-prescription-modal-footer');
    if (footer) {
      delete footer.dataset.ciwLaUploadFooterReady;
    }
  }

  function clearManualRxStepContentBodyClasses() {
    var contentBody = getManualRxContentBody();
    if (contentBody) {
      contentBody.classList.remove('ciw-la-manual-rx-step', 'ciw-la-manual-rx-step--mobile');
    }
  }

  function teardownManualRxStepDesktop() {
    if (isMobileRx()) return;

    var form = document.querySelector(FORM_SELECTOR);
    setManualRxStepActive(false);
    if (form) {
      resetManualRxEnhancement(form);
    } else {
      clearManualRxStepContentBodyClasses();
    }
  }

  function teardownManualRxStepOnNavigateBack() {
    if (!isMobileRx()) {
      teardownManualRxStepDesktop();
      return;
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    var wrapper = document.querySelector('.la-prescription-modal-wrapper');
    var form = document.querySelector(FORM_SELECTOR);
    var footer = document.querySelector('.la-prescription-modal-footer');
    if (footer) {
      footer.classList.remove(
        'ciw-la-review-footer--pinned',
        'ciw-la-subtotal-footer--show-action'
      );

      var buttonWrap = footer.querySelector('.la-subtotal-footer-button');
      if (buttonWrap) {
        buttonWrap.style.removeProperty('display');
        buttonWrap.style.removeProperty('height');
        buttonWrap.style.removeProperty('max-height');
        buttonWrap.style.removeProperty('min-height');
        buttonWrap.style.removeProperty('overflow');
        var btn = buttonWrap.querySelector('.la-prescription-form-btn');
        if (btn) {
          btn.style.removeProperty('display');
          btn.style.removeProperty('height');
          btn.style.removeProperty('max-height');
          btn.style.removeProperty('min-height');
          btn.style.removeProperty('overflow');
        }
      }

      if (wrapper && modal && footer.parentElement === modal) {
        wrapper.appendChild(footer);
      }
    }

    if (wrapper) {
      wrapper.classList.remove('ciw-la-flow-step', 'ciw-la-review-footer-active');
    }

    if (form) {
      form.classList.remove('ciw-la-manual-rx-form--mobile', 'ciw-la-manual-rx--ready');
    }

    setManualRxStepActive(false);
    document.documentElement.style.setProperty('--ciw-la-footer-h', '130px');

    var contentBody = getManualRxContentBody();
    if (contentBody) {
      contentBody.classList.remove('ciw-la-manual-rx-step', 'ciw-la-manual-rx-step--mobile');
    }

    clearManualRxContentBodyPendingHide();
    stopManualFooterWatch();
  }

  function startManualFooterWatch() {
    ensureMobileManualFooter();
    bindManualFooterResize(document.querySelector('.la-prescription-modal-footer'));

    var form = document.querySelector(FORM_SELECTOR);
    var isUploadStep = form && form.classList.contains('ciw-la-upload-rx-form--mobile');
    if (isUploadStep) {
      if (manualFooterWatch) {
        window.clearInterval(manualFooterWatch);
        manualFooterWatch = null;
      }
      return;
    }

    if (manualFooterWatch) return;
    manualFooterWatch = window.setInterval(ensureMobileManualFooter, 200);
  }

  function isContactLensFormStep() {
    return isContactLensHost() && !!document.querySelector('.la-quantity-selector-wrapper');
  }

  function setManualRxStepActive(active) {
    var isActive = !!active;
    var modal = document.getElementById('lensadvizor-prescription-modal');
    document.body.classList.toggle('ciw-la-manual-rx-step-active', isActive);
    if (modal) {
      modal.classList.toggle('ciw-la-manual-rx-step-active', isActive);
    }
  }

  function enhanceManualRxForm() {
    if (!document.querySelector('.ciw-pdp')) return;
    if (isContactLensFormStep()) return;

    var form = document.querySelector(FORM_SELECTOR);
    if (!form) return;

    if (
      form.classList.contains('ciw-la-upload-rx-form--mobile') ||
      form.querySelector('.ciw-la-upload-rx-card')
    ) {
      return;
    }

    var rightRx = form.querySelector('.la-right-rx-container');
    var leftRx = form.querySelector('.la-left-rx-container');
    if (!rightRx || !leftRx) return;

    setManualRxStepActive(true);

    var existingCard = form.querySelector('.ciw-la-manual-rx-card:not(.ciw-la-upload-rx-card)');

    if (existingCard) {
      if (!isManualRxEnhancementStale(form)) {
        syncContactLensEyeBlocks(form);
        ensureManualRxCardTail(form, existingCard);
        revealManualRxContentBodyAfterEnhance(form);
        return;
      }

      if (canRefreshRxInPlace(form, existingCard, rightRx, leftRx)) {
        refreshRxSectionInCard(form, existingCard, rightRx, leftRx);
        revealManualRxContentBodyAfterEnhance(form);
        return;
      }

      if (!areRxContainersReady(rightRx, leftRx) && !cardRxGridHasSelects(existingCard)) {
        return;
      }

      resetManualRxEnhancement(form);
    }

    if (!areRxContainersReady(rightRx, leftRx)) {
      return;
    }

    var fieldsWrapper = form.querySelector('.la-fields-wrapper');
    if (!fieldsWrapper) return;

    form.classList.add('ciw-la-manual-rx-form', 'ciw-la-manual-rx-form--mobile');

    var contentBody = form.closest('.la-prescription-modal-content-body');
    if (contentBody) {
      contentBody.classList.add('ciw-la-manual-rx-step', 'ciw-la-manual-rx-step--mobile');
    }

    hideElement(form.querySelector('.la-wrapper-heading'));
    hideElement(form.querySelector('.la-patient-name-wrapper'));
    hideUploadWrapperPreservingConfirm(form);

    if (isContactLensHost()) {
      form.querySelectorAll('.la-prism-field').forEach(hideElement);
    }

    fieldsWrapper.querySelectorAll('.la-divider').forEach(hideElement);

    var heading = fieldsWrapper.querySelector('.ciw-la-manual-rx-heading');
    if (!heading) {
      heading = buildManualRxHeading();
      fieldsWrapper.insertBefore(heading, fieldsWrapper.firstChild);
    } else if (isContactLensHost()) {
      var headingTitle = heading.querySelector('.ciw-la-manual-rx-heading__title');
      if (headingTitle) {
        headingTitle.textContent = 'Enter your contact lens prescription';
      }
    }

    var card = document.createElement('div');
    card.className = 'ciw-la-manual-rx-card ciw-la-manual-rx-card--mobile';
    card.appendChild(buildRxSection(rightRx, leftRx));

    var pdContainer = form.querySelector('.la-pd-container');
    if (pdContainer) {
      enhancePdSection(pdContainer);
      card.appendChild(pdContainer);
    }

    if (!isContactLensHost()) {
    var prismField = form.querySelector('.la-prism-field');
    if (prismField) {
      var prismWrapper = prismField.closest('.la-prescription-fields-wrapper');
      if (prismWrapper) {
        enhancePrismSection(prismWrapper);
        card.appendChild(prismWrapper);
        }
      }
    }

    if (heading.nextSibling !== card) {
      fieldsWrapper.insertBefore(card, heading.nextSibling);
    }

    syncContactLensEyeBlocks(form);
    if (!isContactLensHost()) {
    bindPrismObserver(form);
    schedulePrismEnhance();
      ensureManualRxCardTail(form, card);
    }
    sanitizeManualRxValidation(form);
    form.classList.add('ciw-la-manual-rx--ready');
    revealManualRxContentBodyAfterEnhance(form);
    startManualFooterWatch();
    document.dispatchEvent(new CustomEvent('ciw-la-manual-rx:enhanced'));
  }

  function ensurePrismObserver() {
    var form = document.querySelector(FORM_SELECTOR);
    if (form && form.querySelector(ENHANCED_MARKER)) {
      bindPrismObserver(form);
    }
  }

  function scheduleEnhance() {
    runPrismGuard();
    enhanceManualRxForm();
    ensurePrismObserver();
    reEnhancePrism();
    schedulePrismEnhance();
    ensureMobileManualFooter();
    window.setTimeout(function () {
      enhanceManualRxForm();
      ensurePrismObserver();
      reEnhancePrism();
      schedulePrismEnhance();
      ensureMobileManualFooter();
    }, 0);
    window.setTimeout(function () {
      enhanceManualRxForm();
      ensurePrismObserver();
      reEnhancePrism();
      schedulePrismEnhance();
      ensureMobileManualFooter();
    }, 150);
    window.setTimeout(function () {
      enhanceManualRxForm();
      ensurePrismObserver();
      reEnhancePrism();
      schedulePrismEnhance();
      ensureMobileManualFooter();
      sanitizeManualRxValidation();
      document.dispatchEvent(new CustomEvent('ciw-la-manual-rx:enhanced'));
    }, 400);
    [800, 1500, 2500, 4000, 6000, 8000, 10000].forEach(function (delay) {
      window.setTimeout(function () {
        enhanceManualRxForm();
        ensurePrismObserver();
        reEnhancePrism();
        schedulePrismEnhance();
        ensureMobileManualFooter();
        var form = document.querySelector(FORM_SELECTOR);
        var card = form && form.querySelector('.ciw-la-manual-rx-card--mobile');
        if (form && card && isConfirmMissingFromCard(form, card)) {
          ensureManualRxCardTail(form, card);
        }
      }, delay);
    });
  }

  function bind() {
    bindManualRxSubmitGuard();

    document.addEventListener('LensAdvizor:render:manualEntryForm', function () {
      hideManualRxContentBodyForEnhance();
      scheduleEnhance();
    });
    document.addEventListener('LensAdvizor:render:submissionMethods', function () {
      teardownManualRxStepOnNavigateBack();
    });
    document.addEventListener('LensAdvizor:selectLensModal:open', scheduleEnhance);
    document.addEventListener('LensAdvizor:selectLensModal:close', function () {
      stopManualFooterWatch();
      clearManualRxContentBodyPendingHide();
      if (!isMobileRx()) {
        setManualRxStepActive(false);
        clearManualRxStepContentBodyClasses();
      }
    });
    document.addEventListener('LensAdvizor:review:rendered', function () {
      window.setTimeout(syncCommentToReviewField, 0);
    });
    document.addEventListener('LensAdvizor:component:DidMount', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.method === 'renderManualEntryForm') {
        scheduleEnhance();
      }
    });

    if (typeof MQ_MOBILE_RX.addEventListener === 'function') {
      MQ_MOBILE_RX.addEventListener('change', scheduleEnhance);
    } else if (typeof MQ_MOBILE_RX.addListener === 'function') {
      MQ_MOBILE_RX.addListener(scheduleEnhance);
    }

    document.addEventListener('click', function (event) {
      if (
        event.target.closest(
          '.la-canEnterPrescriptionManually, #submission-type-1, .la-submission-type-1, .la-submission-type-manual, [data-submission-type="manual"], .la-manual-entry, .la-manual-prescription-entry'
        )
      ) {
        window.setTimeout(scheduleEnhance, 300);
        window.setTimeout(scheduleEnhance, 800);
      }
    });

    ensurePrismObserver();
    schedulePrismEnhance();
  }

  window.ciwLaManualRxEnhanceApi = {
    hideElement: hideElement,
    revealElement: function (el) {
      if (!el) {
        return;
      }

      el.classList.remove('ciw-la-manual-rx-hidden');
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
    },
    enhancePdSection: enhancePdSection,
    syncPdLayout: syncPdLayout,
    buildRxSection: buildRxSection,
    areRxContainersReady: areRxContainersReady,
    refreshRxSectionInCard: refreshRxSectionInCard,
    cardRxGridHasSelects: cardRxGridHasSelects,
    restoreNativeRxFields: restoreNativeRxFields,
    ensurePrescriptionConfirmInCard: ensurePrescriptionConfirmInCard,
    ensureFallbackPrescriptionConfirm: ensureFallbackPrescriptionConfirm,
    scheduleConfirmInCard: scheduleConfirmInCard,
    extractConfirmFromUploadWrapper: extractConfirmFromUploadWrapper,
    isConfirmInCard: isConfirmInCard,
    dedupePrescriptionConfirmRows: dedupePrescriptionConfirmRows,
    hideNativeConfirmInsideUploadWrapper: hideNativeConfirmInsideUploadWrapper,
    normalizePrescriptionConfirmRow: normalizePrescriptionConfirmRow,
    hideUploadWrapperConfirmNode: hideUploadWrapperConfirmNode,
    findPrescriptionConfirmRow: findPrescriptionConfirmRow,
    findPrescriptionConfirmCheckbox: findPrescriptionConfirmCheckbox,
    hasAnyPrescriptionConfirm: hasAnyPrescriptionConfirm,
    syncPrescriptionConfirmLabel: syncPrescriptionConfirmLabel,
    refreshManualFooterInset: refreshManualFooterInset,
    ensureMobileManualFooter: ensureMobileManualFooter,
    startManualFooterWatch: startManualFooterWatch,
    stopManualFooterWatch: stopManualFooterWatch
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
